import {
  Box,
  ClickAwayListener,
  Collapse,
  Divider,
  FormGroup,
  Grow,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Popper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  Tooltip,
  Button,
  CircularProgress,
  Skeleton,
} from "@mui/material";
import Switch from "@mui/material/Switch";
import { styled, useTheme } from "@mui/material/styles";
import React, {
  useEffect,
  useLayoutEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
  useId,
  createContext,
  useContext,
} from "react";
import AccountBilling from "../../assets/image/icons/Account & Billing.svg";
import Activity from "../../assets/image/icons/Activity.svg";
import ManageTeam from "../../assets/image/icons/Manage Team.svg";
import Logout from "../../assets/image/icons/Log out.svg";
import settingiconsidebar from "../../assets/White-sidebar-icon/setting-profile-icon.svg";
import SearchIcon from "@mui/icons-material/Search";
import {
  Breadcrumb,
  BreadcrumbItem,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  UncontrolledDropdown,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "reactstrap";
import BlueButton from "../Button/BlueButton";
import SearchInput from "../InputFields/SearchInput";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import AddIcon from "@mui/icons-material/Add";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import "./style.css";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  useLocation,
  useNavigate,
  useParams,
  Navigate,
} from "react-router-dom";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
/**
 * Cloud Job Manager — nav (style guide §10), data lists/tables (§12), status pills (§6).
 * Guide §§9–14 (broader layout / dashboards / shells): aligned via design tokens and shells such as
 * `cj-data-table-shell`, not a full IA rebuild (PDF layout detail is not machine-extracted here).
 * Tokens: `index.css` :root + MUI theme. Status pills + tone helpers: `./jobberListStatus.jsx` (re-exported below).
 */
import routes from "../../routes";
import setting from "../../assets/White-sidebar-icon/setting-profile.svg";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { handleAuth } from "../Login/Auth";
import NotificationPage from "../Notification/NotificationPage";
import { Grid } from "@mui/material";
import Notifications from "../Notification/viewallnotification";
import { NoDataFound } from "../ContractComponent/Index";
import AxiosInstance from "../../utils/axiosInstance";
import { getItem, clear } from "../../utils/storage";
import { jwtDecode } from "jwt-decode";
import {
  CJ_PORTAL_GUTTER_DESKTOP_PX,
  CJ_PORTAL_GUTTER_TABLET_PX,
  CJ_PORTAL_SIDEBAR_COLLAPSED_PX,
  CJ_PORTAL_SIDEBAR_EXPANDED_PX,
} from "../../utils/cjPortalSidebarMetrics";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import SyncAltOutlinedIcon from "@mui/icons-material/SyncAltOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import { useUserType } from "../../contexts/UserTypeContext";
import { useAdminDarkMode } from "../../contexts/AdminDarkModeContext";
import { useCustomerDarkMode } from "../../contexts/CustomerDarkModeContext";
import DonorSetting from "../../assets/Donor/donor-setting.svg";
import DonorNotification from "../../assets/Donor/Notification-donor.svg";
import ChatBotIcon from "../../assets/svg/ChatBotIcon.svg";
import DonorChatBotIcon from "../../assets/Donor/DonorChatBotIcon.svg";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import useCountNotifications from "../Notification/countNotifications";
import AIChat from "../ChatBot/AiChat";
import { LoaderComponent } from "../Icon/Index";

export {
  JobberStatusBadge,
  getJobberStatusTone,
  getVisitAppointmentStatusTone,
  getCustomerContractListStatusTone,
} from "./jobberListStatus";

/** When true, `JobberTable` shows skeleton/spinner in tbody only; thead stays visible. */
const JobberListCardLoaderContext = createContext({
  listLoading: false,
  listLoadingUseSpinner: false,
});

const AntSwitch = styled(Switch)(({ theme, isDonationMode }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: isDonationMode ? "#68b2cb" : "#0f2b46",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "var(--shadow-sm)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));


/**
 * Responsive JobberTable Component
 * 
 * Features:
 * - Automatically detects mobile screens (< 775px)
 * - Shows limited columns on mobile with collapsible details
 * - Preserves action column functionality (Edit, Delete buttons work)
 * - Action buttons available in both main view and collapsible section
 * - Includes "View Details" button for navigation (only when isNavigate or isDialog is true)
 * - Prevents row click when clicking action buttons
 * - First column is dedicated to collapse/expand icons (blank header) - Mobile only
 * 
 * Props:
 * @param {Array} headerData - Table header configuration
 * @param {Array} cellData - Table row data
 * @param {Component} CollapseComponent - Component to render in desktop collapse
 * @param {boolean} isCollapse - Enable collapse functionality
 * @param {boolean} isDialog - Enable dialog functionality
 * @param {Function} onDialogOpen - Dialog open handler
 * @param {boolean} isNavigate - Enable navigation functionality
 * @param {string} navigatePath - Path for navigation
 * @param {Function} setSortField - Sort field setter
 * @param {Function} setSortOrder - Sort order setter
 * @param {string} sortOrder - Current sort order
 * @param {string} sortField - Current sort field
 * @param {Array} navigats - Navigation state
 * @param {number} mobileColumns - Number of columns to show on mobile (default: 2)
 * @param {number} actionColumnIndex - Index of action column to preserve (optional)
 * @param {boolean} mobileCardLayout - When true with mobile collapse, rows render as expandable cards (default: true). Set false for the legacy mobile table layout.
 * @param {number|null} mobileCardPrimaryColumnIndex - Card title column index (default: 0)
 * @param {number|null} mobileCardSubtitleColumnIndex - Secondary line (e.g. created date); auto-detected from headers when null
 * @param {number|null} mobileCardStatusColumnIndex - Status chip column; auto-detected when null
 * 
 * Usage Example:
 * 
 * // With navigation (shows "View Details" button):
 * <JobberTable
 *   headerData={[
 *     { label: "Name", field: "name" },
 *     { label: "Email", field: "email" },
 *     { label: "Status", field: "status" },
 *     { label: "Actions", field: "actions" }
 *   ]}
 *   cellData={[
 *     { key: 1, value: ["John Doe", "john@example.com", "Active", "Edit"] },
 *     { key: 2, value: ["Jane Smith", "jane@example.com", "Inactive", "Edit"] }
 *   ]}
 *   mobileColumns={2}
 *   actionColumnIndex={3}
 *   isNavigate={true}
 *   navigatePath="/user/details"
 * />
 * 
 * // Without navigation (no "View Details" button):
 * <JobberTable
 *   headerData={headerData}
 *   cellData={cellData}
 *   mobileColumns={2}
 *   actionColumnIndex={3}
 *   // No isNavigate or isDialog props
 * />
 */
// const JobberTable = ({
//   headerData,
//   cellData,
//   CollapseComponent,
//   isCollapse,
//   isDialog = false,
//   onDialogOpen,
//   isNavigate = false,
//   navigatePath,
//   setSortField,
//   setSortOrder,
//   sortOrder,
//   sortField,
//   navigats,
//   mobileColumns = 2, // Number of columns to show on mobile
//   actionColumnIndex = null, // Index of action column to preserve
// }) => {
//   const [collapseIndex, setCollapseIndex] = useState(null);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const isMobile = useMediaQuery("(max-width: 775px)");

//   const handleRowClick = (index, id, rowData) => {
//     if (isMobile) {
//       setCollapseIndex(collapseIndex === index ? null : index);
//     } else {
//       setCollapseIndex(collapseIndex === index ? null : index);

//       if (isNavigate && navigatePath) {
//         const newPath = navigatePath.split("/");
//         const navigationState = navigate ? navigats : location?.state?.navigats;

//         navigate(navigatePath, {
//           state: {
//             id,
//             navigats: [
//               ...(navigationState || []),
//               `/${newPath[newPath.length - 1]}`,
//             ],
//           },
//         });
//       }

//       if (isDialog && onDialogOpen) {
//         onDialogOpen(rowData);
//       }
//     }
//   };

//   const handleViewClick = (id, rowData) => {
//     if (isNavigate && navigatePath) {
//       const newPath = navigatePath.split("/");
//       const navigationState = navigate ? navigats : location?.state?.navigats;

//       navigate(navigatePath, {
//         state: {
//           id,
//           navigats: [
//             ...(navigationState || []),
//             `/${newPath[newPath.length - 1]}`,
//           ],
//         },
//       });
//     }

//     if (isDialog && onDialogOpen) {
//       onDialogOpen(rowData);
//     }
//   };

//   // Get columns to display based on screen size
//   const getDisplayColumns = () => {
//     if (isMobile) {
//       const visibleColumns = [];
      
//       // Add first few columns
//       for (let i = 0; i < Math.min(mobileColumns, headerData?.length); i++) {
//         visibleColumns.push(headerData[i]);
//       }
      
//       // Add action column if specified
//       if (actionColumnIndex !== null && actionColumnIndex < headerData?.length) {
//         visibleColumns.push(headerData[actionColumnIndex]);
//       }
      
//       return visibleColumns;
//     }
//     return headerData;
//   };

//   const getHiddenColumns = () => {
//     if (isMobile) {
//       const visibleIndices = new Set();
      
//       // Add first few columns indices
//       for (let i = 0; i < Math.min(mobileColumns, headerData?.length); i++) {
//         visibleIndices.add(i);
//       }
      
//       // Add action column index if specified
//       if (actionColumnIndex !== null && actionColumnIndex < headerData?.length) {
//         visibleIndices.add(actionColumnIndex);
//       }
      
//       return headerData?.filter((_, index) => !visibleIndices.has(index)) || [];
//     }
//     return [];
//   };

//   // Check if collapse functionality should be shown
//   const shouldShowCollapse = () => {
//     if (!isMobile) return false;
    
//     // If there are 2 or fewer columns and mobileColumns is 2 or more, don't show collapse
//     // (all columns are visible, so no need for collapse)
//     if (headerData?.length <= 2 && mobileColumns >= 2) {
//       return false;
//     }
    
//     const hiddenColumns = getHiddenColumns();
//     // Show collapse if there are hidden columns, or if isCollapse is enabled, or if there's navigation/dialog functionality
//     return hiddenColumns.length > 0 || isCollapse || isNavigate || isDialog;
//   };

//   const handleSort = (field) => {
//     if (!setSortField || !setSortOrder) return; 
//     const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";  
//     setSortField(field);
//     setSortOrder(order);
//   };
//   const { userType: tableUserType } = useUserType();
//   const isDonationMode = tableUserType === "donor";

//   return (
//     <Grid style={{ 
//       overflow: isMobile ? "hidden" : "auto",
//       maxWidth: "100%",
//       width: "100%"
//     }}>
//       <Table style={{
//         width: "100%",
//         tableLayout: isMobile ? "fixed" : "auto",
//         maxWidth: "100%"
//       }}>
//         <TableHead>
//           <TableRow>
//             {/* Empty column for collapse icon - only on mobile and when there's content to expand */}
//             {shouldShowCollapse() && (
//               <TableCell
//                 className={`${
//                   isDonationMode ? "bg-green-color" : "bg-orange-color"
//                 } text-white-color`}
//                 style={{
//                   width: "50px",
//                   textAlign: "center",
//                   padding: "8px",
//                 }}
//               >
//                 {/* Empty header - collapse icon will be in the cell */}
//               </TableCell>
//             )}

//             {getDisplayColumns() &&
//               getDisplayColumns()?.map((item, index) => (
//                 <TableCell
//                   className={`${
//                     isDonationMode ? "bg-green-color  " : "bg-orange-color"
//                   } text-white-color`}
//                   key={index}
//                   style={{
//                     fontWeight: "600",
//                     cursor: item?.field ? "pointer" : "default",
//                     textAlign: item?.align ?? "left",
//                     ...item?.style,
//                   }}
//                   onClick={() => item?.field && handleSort(item?.field)}
//                 >
//                   {item?.label || "item not available"}
//                   {sortField === item?.field && (
//                     <>
//                       {sortOrder === "asc" ? (
//                         <ArrowDropUpIcon />
//                       ) : (
//                         <ArrowDropDownIcon />
//                       )}
//                     </>
//                   )}
//                 </TableCell>
//               ))}
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {cellData?.length > 0 ? (
//             cellData?.map((item, index) => (
//               <React.Fragment key={index}>
//                 <TableRow
//                   style={{ cursor: shouldShowCollapse() ? "pointer" : "default" }}
//                   className={item?.className || ""}
//                   onClick={() => shouldShowCollapse() && handleRowClick(index, item.key, item)}
//                 >
//                   {/* Collapse icon column - only on mobile and when there's content to expand */}
//                   {shouldShowCollapse() && (
//                     <TableCell
//                       style={{
//                         width: "50px",
//                         textAlign: "center",
//                         padding: "8px",
//                       }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleRowClick(index, item.key, item);
//                       }}
//                     >
//                       <IconButton size="small">
//                         {collapseIndex === index ? (
//                           <ArrowDropUpIcon className="text-blue-color" />
//                         ) : (
//                           <ArrowDropDownIcon className="text-blue-color" />
//                         )}
//                       </IconButton>
//                     </TableCell>
//                   )}

//                   {getDisplayColumns()?.map((column, cellIndex) => {
//                     // Find the original index of this column in the full headerData
//                     const originalIndex = headerData?.findIndex(h => h === column);
                    
//                     return (
//                       <TableCell
//                         key={cellIndex}
//                         className="text-blue-color"
//                         style={{
//                           color: "#0f2b46",
//                           textAlign: column?.align ?? "left",
//                           whiteSpace: isMobile ? "normal" : "nowrap",
//                           wordWrap: isMobile ? "break-word" : "normal",
//                           overflowWrap: isMobile ? "break-word" : "normal",
//                           maxWidth: isMobile ? "150px" : "none",
//                           overflow: isMobile ? "hidden" : "visible",
//                           // textOverflow: isMobile ? "ellipsis" : "clip",
//                         }}
//                         onClick={(e) => {
//                           // If this is an action column, don't trigger row click
//                           if (actionColumnIndex !== null && originalIndex === actionColumnIndex) {
//                             e.stopPropagation();
//                           }
//                         }}
//                       >
//                         {Array.isArray(item?.value) &&
//                         item?.value[originalIndex] !== undefined
//                           ? item?.value[originalIndex]
//                           : "-"}
//                       </TableCell>
//                     );
//                   })}
//                 </TableRow>

//                 {/* Mobile Collapsible Section */}
//                 {shouldShowCollapse() && collapseIndex === index && (
//                   <TableRow>
//                     <TableCell
//                       style={{ paddingBottom: 0, paddingTop: 0 }}
//                       colSpan={getDisplayColumns()?.length + (shouldShowCollapse() ? 1 : 0)}
//                     >
//                       <Collapse in={true} timeout="auto" unmountOnExit>
//                         <div className="mobile-table-collapse">
//                           <div className="mobile-collapse-content">
//                             {/* Hidden columns data */}
//                             {getHiddenColumns()?.map((column, hiddenIndex) => {
//                               const originalIndex = headerData?.findIndex(h => h === column);
//                               return (
//                                 <div key={hiddenIndex} className="mobile-data-row">
//                                   <span className="mobile-data-label">
//                                     {column?.label}:
//                                   </span>
//                                   <div className="mobile-data-value">
//                                     {Array.isArray(item?.value) &&
//                                     item?.value[originalIndex] !== undefined
//                                       ? item?.value[originalIndex]
//                                       : "-"}
//                                   </div>
//                                 </div>
//                               );
//                             })}
                            
//                             {/* Action Buttons in Mobile */}
//                             {actionColumnIndex !== null && (
//                               <div className="mobile-data-row mobile-action-row">
//                                 <span className="mobile-data-label">
//                                   Actions:
//                                 </span>
//                                 <div className="mobile-data-value mobile-action-buttons">
//                                   {Array.isArray(item?.value) &&
//                                   item?.value[actionColumnIndex] !== undefined
//                                     ? item?.value[actionColumnIndex]
//                                     : "-"}
//                                 </div>
//                               </div>
//                             )}
                            
//                             {/* View Button - only show if navigation is enabled */}
//                             {((isNavigate === true && navigatePath) || (isDialog === true && onDialogOpen)) && (
//                               <Button
//                                 variant="contained"
//                                 className="mobile-view-button"
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleViewClick(item.key, item);
//                                 }}
//                                 style={{
//                                   backgroundColor: isDonationMode ? "#68b2cb" : "#0f2b46",
//                                   color: "white",
//                                 }}
//                               >
//                                 View Details
//                               </Button>
//                             )}
//                           </div>
//                         </div>
//                       </Collapse>
//                     </TableCell>
//                   </TableRow>
//                 )}

//                 {/* Original Collapse Component */}
//                 {!isMobile && isCollapse && collapseIndex === index && (
//                   <TableRow>
//                     <TableCell
//                       style={{ paddingBottom: 0, paddingTop: 0 }}
//                       colSpan={headerData?.length}
//                     >
//                       <Collapse in={true} timeout="auto" unmountOnExit>
//                         {CollapseComponent && (
//                           <CollapseComponent data={item?.component} />
//                         )}
//                       </Collapse>
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </React.Fragment>
//             ))
//           ) : (
//             <TableRow>
//               <TableCell
//                 align="center"
//                 className="text-blue-color"
//                 colSpan={getDisplayColumns()?.length + (shouldShowCollapse() ? 1 : 0)}
//               >
//                 <NoDataFound isDonationMode={isDonationMode} />
//               </TableCell>
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>
//     </Grid>
//   );
// };
const JobberTable = ({
  headerData,
  cellData,
  CollapseComponent,
  isCollapse,
  isDialog = false,
  onDialogOpen,
  isNavigate = false,
  navigatePath,
  setSortField,
  setSortOrder,
  sortOrder,
  sortField,
  navigats,
  mobileColumns = 2,
  actionColumnIndex = null,
  enableMobileCollapse = true,
  getNavigateState,
  /** When true (default), mobile uses card + expand pattern like the Customers reference. Set false to keep the legacy mobile table (N columns + chevron column). */
  mobileCardLayout = true,
  /** Optional column index for card title row; default 0 */
  mobileCardPrimaryColumnIndex = null,
  /** Optional; auto-detects "Created" / createdAt-style columns when null */
  mobileCardSubtitleColumnIndex = null,
  /** Optional; auto-detects Status / IsActive when null */
  mobileCardStatusColumnIndex = null,
  /** When false, hides the navy "View Details" button in mobile expanded rows (e.g. Customer list uses inline View). Default true. */
  showMobileViewDetailsButton = true,
  /** When `false`, never show tbody loading from parent card. When `true`, force tbody loading. When omitted, use JobberListCard context. */
  loader,
  /** Rows of skeleton cells when list is loading (non-spinner). */
  loadingSkeletonRows = 10,
  /** Override card context: use dotted spinner row instead of skeleton rows (donor lists). */
  loadingUseSpinner,
}) => {
  const [collapseIndex, setCollapseIndex] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width: 775px)");
  const prevDataKeysRef = useRef(null);

  const useMobileCards =
    isMobile && enableMobileCollapse && mobileCardLayout;

  const resolvedActionColumnIndex = useMemo(() => {
    if (actionColumnIndex != null && actionColumnIndex >= 0) {
      return actionColumnIndex;
    }
    const idx = headerData?.findIndex((h) =>
      /^actions$/i.test(String(h?.label ?? "").trim())
    );
    return idx >= 0 ? idx : null;
  }, [actionColumnIndex, headerData]);

  const mobileCardIndices = useMemo(() => {
    if (!mobileCardLayout) {
      return {
        primaryIndex: 0,
        subtitleIndex: null,
        statusIndex: null,
      };
    }
    const primaryIndex =
      mobileCardPrimaryColumnIndex != null && mobileCardPrimaryColumnIndex >= 0
        ? mobileCardPrimaryColumnIndex
        : 0;

    let subtitleIndex = mobileCardSubtitleColumnIndex;
    if (subtitleIndex === undefined || subtitleIndex === null) {
      const si = headerData?.findIndex((h) => {
        const f = String(h?.field ?? "").toLowerCase();
        const lb = String(h?.label ?? "").toLowerCase();
        return (
          f.includes("createdat") ||
          f.includes("created") ||
          lb.includes("created on") ||
          (lb.includes("created") && lb.includes("on"))
        );
      });
      subtitleIndex = si != null && si >= 0 ? si : null;
    }
    if (subtitleIndex === primaryIndex) {
      subtitleIndex = null;
    }

    let statusIndex = mobileCardStatusColumnIndex;
    if (statusIndex === undefined || statusIndex === null) {
      const st = headerData?.findIndex((h) => {
        const f = String(h?.field ?? "").toLowerCase();
        const lb = String(h?.label ?? "").toLowerCase();
        return (
          f.includes("isactive") ||
          f.includes("status") ||
          lb === "status"
        );
      });
      statusIndex = st != null && st >= 0 ? st : null;
    }
    if (statusIndex === primaryIndex) {
      statusIndex = null;
    }

    return { primaryIndex, subtitleIndex, statusIndex };
  }, [
    mobileCardLayout,
    headerData,
    mobileCardPrimaryColumnIndex,
    mobileCardSubtitleColumnIndex,
    mobileCardStatusColumnIndex,
  ]);

  const mobileCardDetailColumnIndices = useMemo(() => {
    if (!useMobileCards || !headerData?.length) {
      return [];
    }
    const { primaryIndex, subtitleIndex, statusIndex } = mobileCardIndices;
    const summary = new Set(
      [primaryIndex, subtitleIndex, statusIndex].filter(
        (i) => i != null && i >= 0
      )
    );
    const act = resolvedActionColumnIndex;
    return headerData
      .map((_, i) => i)
      .filter((i) => {
        if (summary.has(i)) return false;
        if (act != null && i === act) return false;
        /* e.g. Email Campaign: keep a desktop-only column (Send icon) but show Send only in mobile action row */
        if (headerData[i]?.omitFromMobileCardDetail === true) return false;
        return true;
      });
  }, [
    useMobileCards,
    headerData,
    mobileCardIndices,
    resolvedActionColumnIndex,
  ]);

  // Reset collapse state when cellData changes (e.g., filtering, searching, pagination)
  useEffect(() => {
    // Get current keys from cellData
    const currentKeys = cellData?.map(item => item?.key) || [];
    const currentKeysString = JSON.stringify(currentKeys.sort());
    const prevKeysString = prevDataKeysRef.current ? JSON.stringify(prevDataKeysRef.current.sort()) : null;
    
    // If the set of keys has changed (data filtered/reloaded), reset collapse state
    if (prevKeysString !== null && currentKeysString !== prevKeysString) {
      setCollapseIndex(null);
    }
    
    // Update ref with current keys for next comparison
    prevDataKeysRef.current = currentKeys;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cellData]);

  const handleRowClick = (index, id, rowData) => {
    // On mobile with collapse enabled: only expand/collapse row; "View Details" button handles navigation
    if (isMobile && enableMobileCollapse) {
      setCollapseIndex(collapseIndex === index ? null : index);
      return;
    }
    if (isNavigate && navigatePath) {
      const newPath = navigatePath.split("/");
      const navigationState = navigate ? navigats : location?.state?.navigats;
      const baseState = {
        id,
        navigats: [
          ...(navigationState || []),
          `/${newPath[newPath.length - 1]}`,
        ],
      };
      const extraState = typeof getNavigateState === "function" ? getNavigateState(rowData) || {} : {};
      navigate(navigatePath, { state: { ...baseState, ...extraState } });
      return;
    }
    if (isMobile) {
      if (enableMobileCollapse) {
        setCollapseIndex(collapseIndex === index ? null : index);
      }
    } else {
      setCollapseIndex(collapseIndex === index ? null : index);
      if (isDialog && onDialogOpen) {
        onDialogOpen(rowData);
      }
    }
  };

  const handleViewClick = (id, rowData, isFromViewDetailsButton = false) => {
    if (isNavigate && navigatePath) {
      const newPath = navigatePath.split("/");
      const navigationState = navigate ? navigats : location?.state?.navigats;
      const baseState = {
        id,
        navigats: [
          ...(navigationState || []),
          `/${newPath[newPath.length - 1]}`,
        ],
      };
      const extraState = typeof getNavigateState === "function" ? getNavigateState(rowData) || {} : {};
      navigate(navigatePath, { state: { ...baseState, ...extraState } });
    }

    if (isDialog && onDialogOpen) {
      onDialogOpen({ ...rowData, _isFromViewDetailsButton: isFromViewDetailsButton });
    }
  };

  const getDisplayColumns = () => {
    if (isMobile) {
      const visibleColumns = [];

      for (let i = 0; i < Math.min(mobileColumns, headerData?.length); i++) {
        visibleColumns.push(headerData[i]);
      }
      
      if (
        resolvedActionColumnIndex != null &&
        resolvedActionColumnIndex < headerData?.length
      ) {
        visibleColumns.push(headerData[resolvedActionColumnIndex]);
      }

      return visibleColumns;
    }
    return headerData;
  };

  const getHiddenColumns = () => {
    if (isMobile) {
      const visibleIndices = new Set();
      
      for (let i = 0; i < Math.min(mobileColumns, headerData?.length); i++) {
        visibleIndices.add(i);
      }
      
      if (
        resolvedActionColumnIndex != null &&
        resolvedActionColumnIndex < headerData?.length
      ) {
        visibleIndices.add(resolvedActionColumnIndex);
      }

      return headerData?.filter((_, index) => !visibleIndices.has(index)) || [];
    }
    return [];
  };

  const handleSort = (field) => {
    if (!setSortField || !setSortOrder) return; 
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";  
    setSortField(field);
    setSortOrder(order);
  };
  const { userType: tableUserType } = useUserType();
  const isDonationMode = tableUserType === "donor";
  const { listLoading, listLoadingUseSpinner } = useContext(
    JobberListCardLoaderContext
  );
  const showBodyLoading =
    loader === false
      ? false
      : loader === true
        ? true
        : Boolean(listLoading);
  const useSpinnerForBody =
    loadingUseSpinner !== undefined && loadingUseSpinner !== null
      ? loadingUseSpinner
      : listLoadingUseSpinner;

  const skeletonColCount =
    (getDisplayColumns()?.length || 0) +
    (isMobile && enableMobileCollapse ? 1 : 0);

  return (
    <Grid
      className={[
        useMobileCards ? "jobber-table-mobile-cards-wrap" : "",
        "cj-data-table-shell",
      ]
        .filter(Boolean)
        .join(" ")}
      style={{
        overflow: isMobile ? "hidden" : "auto",
        maxWidth: "100%",
        width: "100%",
      }}
    >
      <Table
        className={["jobber-table-v2", useMobileCards ? "jobber-table-v2--mobile-cards" : ""]
          .filter(Boolean)
          .join(" ")}
        style={{
        width: "100%",
        tableLayout: isMobile ? "fixed" : "auto",
        maxWidth: "100%"
      }}>
        {!useMobileCards && (
        <TableHead>
          <TableRow>
            {isMobile && enableMobileCollapse && (
              <TableCell
                className="jobber-table-v2__th jobber-table-v2__th--collapse"
                style={{
                  width: "50px",
                  textAlign: "center",
                  padding: "8px",
                }}
              >
              </TableCell>
            )}

            {getDisplayColumns() &&
              getDisplayColumns()?.map((item, index) => {
                // Check if this is the Reason column header or Description column that should wrap
                const isReasonColumn = item?.field === 'voidReason' || 
                                     item?.label?.toLowerCase() === 'reason';
                const isDescriptionColumn = item?.label?.toLowerCase() === 'description' && 
                                           item?.className === 'billing-history-description-column';
                const shouldWrap = isReasonColumn || isDescriptionColumn || item?.wrap === true;
                
                return (
                <TableCell
                  className="jobber-table-v2__th"
                  key={index}
                  style={{
                    fontWeight: "600",
                    cursor: item?.field ? "pointer" : "default",
                    textAlign: item?.align ?? "left",
                    whiteSpace: shouldWrap ? "normal" : "nowrap",
                    wordWrap: shouldWrap ? "break-word" : "normal",
                    overflowWrap: shouldWrap ? "break-word" : "normal",
                    minWidth: shouldWrap ? (isDescriptionColumn ? "200px" : "200px") : "auto",
                    maxWidth: shouldWrap ? (isDescriptionColumn ? "500px" : "300px") : "none",
                    ...item?.style,
                  }}
                  onClick={() => item?.field && handleSort(item?.field)}
                >
                  <span className="jobber-table-v2__th-label">
                  {item?.label || "item not available"}
                  </span>
                  {sortField === item?.field && (
                    <>
                      {sortOrder === "asc" ? (
                        <ArrowDropUpIcon
                          className="jobber-table-v2__sort-icon jobber-table-v2__sort-icon--active"
                          fontSize="small"
                        />
                      ) : (
                        <ArrowDropDownIcon
                          className="jobber-table-v2__sort-icon jobber-table-v2__sort-icon--active"
                          fontSize="small"
                        />
                      )}
                    </>
                  )}
                </TableCell>
              )})}
          </TableRow>
        </TableHead>
        )}
        <TableBody>
          {showBodyLoading ? (
            useSpinnerForBody ? (
              <TableRow>
                <TableCell
                  colSpan={skeletonColCount || 1}
                  align="center"
                  className="jobber-table-v2__td"
                  sx={{ py: 5 }}
                >
                  <LoaderComponent
                    loader={true}
                    variant="spinner"
                    height={50}
                    width={50}
                  />
                </TableCell>
              </TableRow>
            ) : (
              Array.from({ length: loadingSkeletonRows }, (_, ri) => (
                <TableRow key={`jobber-sk-${ri}`} className="jobber-table-v2__row">
                  {isMobile && enableMobileCollapse && (
                    <TableCell className="jobber-table-v2__td" sx={{ py: 1.25 }}>
                      <Skeleton
                        variant="rounded"
                        width={28}
                        height={28}
                        animation="wave"
                        sx={{ borderRadius: "6px", mx: "auto" }}
                      />
                    </TableCell>
                  )}
                  {getDisplayColumns()?.map((_, ci) => (
                    <TableCell
                      key={ci}
                      className="jobber-table-v2__td"
                      sx={{ py: 1.25 }}
                    >
                      <Skeleton
                        variant="rounded"
                        height={28}
                        width="92%"
                        animation="wave"
                        sx={{ borderRadius: "6px" }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )
          ) : cellData?.length > 0 ? (
            useMobileCards ? (
            cellData?.map((item, index) => {
              const rowReactKey =
                item?.key != null && String(item.key).trim() !== ""
                  ? String(item.key)
                  : `jobber-row-${index}`;
              const { primaryIndex, subtitleIndex, statusIndex } = mobileCardIndices;
              const colSpan = Math.max(headerData?.length || 1, 1);

              const renderDetailRows = () =>
                mobileCardDetailColumnIndices.map((hiddenIndex) => {
                  const column = headerData[hiddenIndex];
                  const originalIndex = hiddenIndex;
                  const isReasonColumn =
                    column?.field === "voidReason" ||
                    column?.label?.toLowerCase() === "reason";
                  const isDescriptionColumn =
                    column?.label?.toLowerCase() === "description" &&
                    column?.className === "billing-history-description-column";
                  const shouldWrap =
                    isReasonColumn || isDescriptionColumn || column?.wrap === true;
                  const justifyWrappedText = isReasonColumn || isDescriptionColumn;

                  return (
                    <div
                      key={`mcard-${rowReactKey}-${hiddenIndex}`}
                      className="mobile-data-row"
                      data-reason={shouldWrap ? "true" : "false"}
                      style={
                        shouldWrap
                          ? {
                              flexDirection: "column",
                              alignItems: "flex-start",
                              width: "100%",
                              marginBottom: "12px",
                            }
                          : {}
                      }
                    >
                      <span className="mobile-data-label">{column?.label}:</span>
                      <div
                        className="mobile-data-value"
                        style={
                          shouldWrap
                            ? {
                                width: "100%",
                                maxWidth: "100%",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                                lineHeight: "1.6",
                                marginTop: "4px",
                                padding: "0",
                                ...(justifyWrappedText
                                  ? { textAlign: "justify", textJustify: "inter-word" }
                                  : { textAlign: "left" }),
                              }
                            : {}
                        }
                      >
                        {Array.isArray(item?.value) &&
                        item?.value[originalIndex] !== undefined
                          ? item?.value[originalIndex]
                          : "-"}
                      </div>
                    </div>
                  );
                });

              return (
                <TableRow
                  key={rowReactKey}
                  hover={false}
                  className={[
                    "jobber-mobile-card-tr",
                    index % 2 === 1 ? "jobber-mobile-card-tr--alt" : "",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                >
                  <TableCell
                    colSpan={colSpan}
                    className="jobber-mobile-card-td"
                    style={{
                      padding: 0,
                      border: "none",
                      verticalAlign: "top",
                    }}
                  >
                    <div
                      className={[
                        "jobber-mobile-card",
                        collapseIndex === index ? "jobber-mobile-card--expanded" : "",
                      ]
                        .filter(Boolean)
                        .join(" ")}
                    >
                      <div
                        role="button"
                        tabIndex={0}
                        aria-expanded={collapseIndex === index}
                        className="jobber-mobile-card__summary"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleRowClick(index, item.key, item);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleRowClick(index, item.key, item);
                          }
                        }}
                      >
                        <div className="jobber-mobile-card__summary-main">
                          <div className="jobber-mobile-card__primary">
                            {Array.isArray(item?.value) &&
                            item?.value[primaryIndex] !== undefined
                              ? item.value[primaryIndex]
                              : "-"}
                          </div>
                          {subtitleIndex != null && (
                            <div className="jobber-mobile-card__subtitle">
                              <span className="jobber-mobile-card__subtitle-label">
                                {headerData[subtitleIndex]?.label || "Created"}
                              </span>
                              <span className="jobber-mobile-card__subtitle-value">
                                {Array.isArray(item?.value) &&
                                item?.value[subtitleIndex] !== undefined
                                  ? item.value[subtitleIndex]
                                  : "-"}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="jobber-mobile-card__summary-end">
                          {statusIndex != null && (
                            <div className="jobber-mobile-card__status">
                              {Array.isArray(item?.value) &&
                              item?.value[statusIndex] !== undefined
                                ? item.value[statusIndex]
                                : "-"}
                            </div>
                          )}
                          <IconButton
                            size="small"
                            className="jobber-mobile-card__chevron"
                            aria-hidden
                            tabIndex={-1}
                          >
                            {collapseIndex === index ? (
                              <ArrowDropUpIcon className="jobber-table-v2__collapse-icon" />
                            ) : (
                              <ArrowDropDownIcon className="jobber-table-v2__collapse-icon" />
                            )}
                          </IconButton>
                        </div>
                      </div>

                      <Collapse in={collapseIndex === index} timeout="auto" unmountOnExit>
                        <div
                          className="jobber-mobile-card__expanded"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Divider
                            sx={{ borderColor: "var(--jobber-border, #e5e7eb)" }}
                          />
                          <div className="mobile-table-collapse jobber-mobile-card__collapse-inner">
                            <div className="mobile-collapse-content">
                              {renderDetailRows()}
                              {resolvedActionColumnIndex != null && (
                                <div className="mobile-data-row mobile-action-row jobber-mobile-card__actions">
                                  <span className="mobile-data-label">Actions:</span>
                                  <div className="mobile-data-value mobile-action-buttons">
                                    {Array.isArray(item?.value) &&
                                    item?.value[resolvedActionColumnIndex] !== undefined
                                      ? item?.value[resolvedActionColumnIndex]
                                      : "-"}
                                  </div>
                                </div>
                              )}

                              {isCollapse && CollapseComponent && (
                                <div
                                  className="mobile-collapse-component"
                                  style={{
                                    marginTop: "15px",
                                    width: "100%",
                                    maxWidth: "100%",
                                    boxSizing: "border-box",
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                  }}
                                >
                                  {CollapseComponent({ data: item?.component })}
                                </div>
                              )}

                              {showMobileViewDetailsButton &&
                                ((isNavigate === true && navigatePath) ||
                                  (isDialog === true && onDialogOpen)) && (
                                <Button
                                  variant="contained"
                                  className="mobile-view-button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewClick(item.key, item, true);
                                  }}
                                  style={{
                                    backgroundColor: isDonationMode ? "#68b2cb" : "var(--navy-deep)",
                                    color: "white",
                                  }}
                                >
                                  View Details
                                </Button>
                              )}
                            </div>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })
            ) : (
            cellData?.map((item, index) => {
              // Stable row identity (like Company list: CompanyId) so avatars/cells track
              // the same entity when sort order changes — index-only keys break reconciliation.
              const rowReactKey =
                item?.key != null && String(item.key).trim() !== ""
                  ? String(item.key)
                  : `jobber-row-${index}`;
              return (
              <React.Fragment key={rowReactKey}>
                <TableRow
                  hover={false}
                  tabIndex={0}
                  className={[
                    "jobber-table-v2__row",
                    "jobber-table-v2__row--clickable",
                    index % 2 === 1 ? "jobber-table-v2__row--alt" : "",
                    collapseIndex === index ? "jobber-table-v2__row--expanded" : "",
                    item?.className || "",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                  onClick={(e) => {
                    if (
                      resolvedActionColumnIndex != null &&
                      typeof e.target?.closest === "function" &&
                      e.target.closest("[data-jobber-action-cell]")
                    ) {
                      e.stopPropagation();
                      return;
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    handleRowClick(index, item.key, item);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      if (
                        resolvedActionColumnIndex != null &&
                        typeof e.target?.closest === "function" &&
                        e.target.closest("[data-jobber-action-cell]")
                      ) {
                        return;
                      }
                      e.preventDefault();
                      handleRowClick(index, item.key, item);
                    }
                  }}
                >
                  {isMobile && enableMobileCollapse && (
                    <TableCell
                      className="jobber-table-v2__td"
                      style={{
                        width: "50px",
                        textAlign: "center",
                        padding: "8px",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleRowClick(index, item.key, item);
                      }}

                    >
                      <IconButton size="small">
                        {collapseIndex === index ? (
                          <ArrowDropUpIcon className="jobber-table-v2__collapse-icon" />
                        ) : (
                          <ArrowDropDownIcon className="jobber-table-v2__collapse-icon" />
                        )}
                      </IconButton>
                    </TableCell>
                  )}

                  {getDisplayColumns()?.map((column, cellIndex) => {
                    let originalIndex = headerData?.findIndex((h) => h === column);
                    if (
                      (originalIndex == null || originalIndex < 0) &&
                      Array.isArray(headerData) &&
                      cellIndex < headerData.length
                    ) {
                      originalIndex = cellIndex;
                    }
                    // Check if this is the Reason column (voidReason field) or Description column that may contain reason text
                    const isReasonColumn = column?.field === 'voidReason' || 
                                         column?.label?.toLowerCase() === 'reason' ||
                                         (headerData && headerData[originalIndex]?.field === 'voidReason') ||
                                         (headerData && headerData[originalIndex]?.label?.toLowerCase() === 'reason');
                    // Check if this is Description column with className indicating it should wrap
                    const isDescriptionColumn = column?.label?.toLowerCase() === 'description' && 
                                             (column?.className === 'billing-history-description-column' ||
                                              (headerData && headerData[originalIndex]?.className === 'billing-history-description-column'));
                    const shouldWrap = isReasonColumn || isDescriptionColumn || column?.wrap === true;
                    // Only Reason/Description use justified text; plain wrap columns (e.g. Contract) look bad with huge word gaps
                    const justifyWrappedText = isReasonColumn || isDescriptionColumn;
                    /* Quote # / Contract # / Invoice # — JobberTableDocRefTitleCell; nowrap td + long title bleeds into next column */
                    const isDocRefTitleColumn =
                      column?.field === "QuoteNumber" ||
                      column?.field === "ContractNumber" ||
                      column?.field === "InvoiceNumber";

                    const isActionColumnCell =
                      resolvedActionColumnIndex != null &&
                      originalIndex === resolvedActionColumnIndex;

                    return (
                      <TableCell
                        key={cellIndex}
                        className="jobber-table-v2__td"
                        data-jobber-action-cell={
                          isActionColumnCell ? "true" : undefined
                        }
                        style={{
                          textAlign: shouldWrap
                            ? (justifyWrappedText ? "justify" : (column?.align ?? "left"))
                            : (column?.align ?? "left"),
                          whiteSpace: shouldWrap ? "normal" : (isMobile ? "normal" : "nowrap"),
                          wordWrap: shouldWrap ? "break-word" : (isMobile ? "break-word" : "normal"),
                          overflowWrap: shouldWrap ? "break-word" : (isMobile ? "break-word" : "normal"),
                          maxWidth: shouldWrap 
                            ? (isMobile ? "100%" : (isDescriptionColumn ? "500px" : "300px")) 
                            : (isMobile ? "150px" : "none"),
                          overflow: shouldWrap ? "visible" : (isMobile ? "hidden" : "visible"),
                          minWidth: shouldWrap 
                            ? (isMobile ? "auto" : (isDescriptionColumn ? "200px" : "200px")) 
                            : "auto",
                          width: shouldWrap && isMobile ? "100%" : "auto",
                          lineHeight: shouldWrap ? "1.5" : "inherit",
                          padding: shouldWrap && isMobile ? "8px 4px" : undefined,
                          textJustify: shouldWrap && justifyWrappedText ? "inter-word" : "auto",
                          ...(isDocRefTitleColumn
                            ? {
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                /* Room for “#102 · Long title” without bleeding into Property; avoid mid-word breaks (not “anywhere”) */
                                maxWidth: isMobile ? "100%" : "min(560px, 52vw)",
                                minWidth: isMobile ? 0 : 260,
                                overflow: "visible",
                              }
                            : {}),
                          ...(column?.style || {}),
                        }}
                        onClick={(e) => {
                          if (isActionColumnCell) {
                            e.stopPropagation();
                          }
                        }}
                      >
                        {Array.isArray(item?.value) &&
                        item?.value[originalIndex] !== undefined
                          ? item?.value[originalIndex]
                          : "-"}
                      </TableCell>
                    );
                  })}
                </TableRow>

                {isMobile && enableMobileCollapse && collapseIndex === index && (
                  <TableRow className="jobber-table-v2__row-nested">
                    <TableCell
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      colSpan={getDisplayColumns()?.length + 1}
                    >
                      <Collapse in={true} timeout="auto" unmountOnExit>
                        <div className="mobile-table-collapse">
                          <div className="mobile-collapse-content">
                            {getHiddenColumns()?.map((column, hiddenIndex) => {
                              const originalIndex = headerData?.findIndex(h => h === column);
                              // Check if this is the Reason column or Description column that should wrap
                              const isReasonColumn = column?.field === 'voidReason' || 
                                                   column?.label?.toLowerCase() === 'reason';
                              const isDescriptionColumn = column?.label?.toLowerCase() === 'description' && 
                                                         column?.className === 'billing-history-description-column';
                              const shouldWrap = isReasonColumn || isDescriptionColumn || column?.wrap === true;
                              const justifyWrappedText = isReasonColumn || isDescriptionColumn;
                              
                              return (
                                <div 
                                  key={hiddenIndex} 
                                  className="mobile-data-row"
                                  data-reason={shouldWrap ? "true" : "false"}
                                  style={shouldWrap ? {
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    width: "100%",
                                    marginBottom: "12px",
                                  } : {}}
                                >
                                  <span className="mobile-data-label">
                                    {column?.label}:
                                  </span>
                                  <div 
                                    className="mobile-data-value"
                                    style={shouldWrap ? {
                                      width: "100%",
                                      maxWidth: "100%",
                                      wordWrap: "break-word",
                                      overflowWrap: "break-word",
                                      whiteSpace: "normal",
                                      lineHeight: "1.6",
                                      marginTop: "4px",
                                      padding: "0",
                                      ...(justifyWrappedText
                                        ? { textAlign: "justify", textJustify: "inter-word" }
                                        : { textAlign: "left" }),
                                    } : {}}
                                  >
                                    {Array.isArray(item?.value) &&
                                    item?.value[originalIndex] !== undefined
                                      ? item?.value[originalIndex]
                                      : "-"}
                                  </div>
                                </div>
                              );
                            })}
                            
                            {resolvedActionColumnIndex != null && (
                              <div className="mobile-data-row mobile-action-row">
                                <span className="mobile-data-label">
                                  Actions:
                                </span>
                                <div className="mobile-data-value mobile-action-buttons">
                                  {Array.isArray(item?.value) &&
                                  item?.value[resolvedActionColumnIndex] !== undefined
                                    ? item?.value[resolvedActionColumnIndex]
                                    : "-"}
                                </div>
                              </div>
                            )}
                            
                            {isCollapse && CollapseComponent && (
                              <div className="mobile-collapse-component" style={{ marginTop: "15px", width: "100%", maxWidth: "100%", boxSizing: "border-box", paddingLeft: 0, paddingRight: 0 }}>
                                {CollapseComponent({ data: item?.component })}
                              </div>
                            )}
                            
                            {showMobileViewDetailsButton &&
                              ((isNavigate === true && navigatePath) ||
                                (isDialog === true && onDialogOpen)) && (
                              <Button
                                variant="contained"
                                className="mobile-view-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewClick(item.key, item, true);
                                }}
                                style={{
                                  backgroundColor: isDonationMode ? "#68b2cb" : "var(--navy-deep)",
                                  color: "white",
                                }}
                              >
                                View Details
                              </Button>
                            )}
                          </div>
                        </div>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                )}

                {!isMobile && isCollapse && collapseIndex === index && (
                  <TableRow className="jobber-table-v2__row-nested">
                    <TableCell
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      colSpan={headerData?.length}
                    >
                      <Collapse in={true} timeout="auto" unmountOnExit>
                        {CollapseComponent && (
                          <CollapseComponent data={item?.component} />
                        )}
                      </Collapse>
                    </TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            );
            })
          )
          ) : (
            <TableRow>
              <TableCell
                align="center"
                className="jobber-table-v2__td jobber-table-v2__td--empty"
                colSpan={
                  useMobileCards
                    ? Math.max(headerData?.length || 1, 1)
                    : getDisplayColumns()?.length + (isMobile && enableMobileCollapse ? 1 : 0)
                }
              >
                <NoDataFound isDonationMode={isDonationMode} />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Grid>
  );
};

/** Jobber style-guide: navy / blue primary / accents — saturated enough for white initials */
const AVATAR_PALETTE = [
  "#0F2B46",
  "#1A3F5C",
  "#2563EB",
  "#059669",
  "#D4943A",
  "#D97706",
  "#DC2626",
];

const hashStringToIndex = (str, modulo) => {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = (Math.imul(31, h) + str.charCodeAt(i)) | 0;
  }
  return modulo ? Math.abs(h) % modulo : 0;
};

const initialsFromName = (name) => {
  if (!name || typeof name !== "string") return "?";
  // Strip parenthetical tags like "(Job)" so the last token is a real name, not "(" or "J".
  // "Owner Deepali (Job)" → "Owner Deepali" → OD (matches sidebar `buildSidebarInitials` intent).
  const cleaned = name
    .replace(/\([^)]*\)/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  const parts = cleaned.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] || ""}${parts[parts.length - 1][0] || ""}`.toUpperCase();
  }
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  return "?";
};

/**
 * Stable row id for report tables: same value for cellData.key, JobberAvatar key, and colorSeed
 * (mirrors Company list: CompanyId per row). Does not change API or sort behavior.
 */
export function jobberReportStableRowId(item, index = 0) {
  if (!item || typeof item !== "object") {
    return `rpt-empty-${index}`;
  }
  const norm = (v) => {
    if (v == null) return null;
    const str =
      typeof v === "object" && typeof v.toString === "function"
        ? v.toString()
        : String(v);
    const t = str.trim();
    return t !== "" ? t : null;
  };

  return (
    norm(item._id) ||
    norm(item.EmailId) ||
    norm(item.invoicePaymentId) ||
    norm(item.InvoicePaymentId) ||
    norm(item.transactionid) ||
    norm(item.transactionId) ||
    norm(item.recurringPaymentId) ||
    norm(item.RecurringPaymentId) ||
    norm(item.makePaymentId) ||
    `rpt-fb|${norm(item.createdAt) || "na"}|${String(item.amount ?? "")}|${norm(item.emailAddress) || norm(item.email) || ""}|${norm(item.Subject) || ""}|${index}`
  );
}

/**
 * Avatar + name for data tables.
 * Background color is derived from `colorSeed` (e.g. row/entity id) when set, otherwise from
 * React useId() so two rows with the same customer name still get different palette colors.
 */
export const JobberAvatar = ({
  name,
  className = "",
  showName = true,
  colorSeed = null,
}) => {
  const reactInstanceId = useId();
  const initials = initialsFromName(name);
  const seed =
    colorSeed != null && String(colorSeed).trim() !== ""
      ? String(colorSeed)
      : reactInstanceId;
  const bg =
    AVATAR_PALETTE[hashStringToIndex(seed, AVATAR_PALETTE.length)];
  return (
    <span
      className={[
        "jobber-avatar-inline",
        !showName && "jobber-avatar-inline--circle-only",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <span
        className="jobber-avatar-inline__circle"
        style={{ backgroundColor: bg }}
        aria-hidden
      >
        {initials}
      </span>
      {showName ? (
        <span className="jobber-avatar-inline__name">{name}</span>
      ) : null}
    </span>
  );
};

/** Display name from a visit worker profile (lookup / AssignPerson / workerDetails item). */
export function workerProfileDisplayNameFromLookup(w) {
  if (!w || typeof w !== "object") return "";
  const n = `${w?.FirstName ?? ""} ${w?.LastName ?? ""}`.trim();
  if (n) return n;
  if (w?.FullName != null && String(w.FullName).trim()) return String(w.FullName).trim();
  if (w?.OwnerName != null && String(w.OwnerName).trim()) return String(w.OwnerName).trim();
  return "";
}

export function workerProfileAvatarSeedFromLookup(w, index) {
  if (w?.UserId != null && w.UserId !== "") return String(w.UserId);
  if (w?.WorkerId != null && w.WorkerId !== "") return String(w.WorkerId);
  return `w-${index}`;
}

/**
 * Worker profile objects for a visit: `workerDetails` (admin schedule) and/or `AssignPerson` (object or array).
 */
export function jobberVisitWorkerProfiles(visit) {
  if (!visit || typeof visit !== "object") return [];
  if (Array.isArray(visit.workerDetails) && visit.workerDetails.length > 0) {
    return visit.workerDetails;
  }
  const ap = visit.AssignPerson;
  if (Array.isArray(ap) && ap.length > 0) return ap;
  if (ap && typeof ap === "object") return [ap];
  return [];
}

/** Comma-separated assigned worker names for search/sort (empty string if none). */
export function jobberVisitAssignedWorkersLabel(visit) {
  const profiles = jobberVisitWorkerProfiles(visit);
  const names = profiles.map((w) => workerProfileDisplayNameFromLookup(w)).filter(Boolean);
  return names.join(", ");
}

const JOBBER_ASSIGNED_WORKER_DASH_SX = {
  fontSize: "0.9375rem",
  whiteSpace: "normal",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  lineHeight: 1.5,
};

/**
 * Table cell: one JobberAvatar per assigned worker (stacked when 2+). Use with `jobberVisitWorkerProfiles(visit)`.
 */
export function JobberAssignedWorkersCell({
  rowKey = "",
  workerProfiles,
  fallbackName = "",
  fallbackColorSeed = null,
  dashTypographySx = JOBBER_ASSIGNED_WORKER_DASH_SX,
}) {
  const dash = (
    <Typography component="div" sx={dashTypographySx}>
      —
    </Typography>
  );
  const arr = Array.isArray(workerProfiles) ? workerProfiles : [];
  const rows = arr
    .map((w, idx) => {
      const name = workerProfileDisplayNameFromLookup(w);
      return name ? { w, name, idx } : null;
    })
    .filter(Boolean);
  if (rows.length > 1) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 1.25,
          minWidth: 0,
        }}
      >
        {rows.map(({ w, name, idx }) => (
          <JobberAvatar
            key={`${rowKey}-${workerProfileAvatarSeedFromLookup(w, idx)}`}
            name={name}
            colorSeed={workerProfileAvatarSeedFromLookup(w, idx)}
          />
        ))}
      </Box>
    );
  }
  if (rows.length === 1) {
    const { w, name, idx } = rows[0];
    return (
      <JobberAvatar name={name} colorSeed={workerProfileAvatarSeedFromLookup(w, idx)} />
    );
  }
  const fb = String(fallbackName || "").trim();
  if (!fb || fb === "—") return dash;
  return (
    <JobberAvatar
      name={fb}
      colorSeed={
        fallbackColorSeed != null && String(fallbackColorSeed).trim() !== ""
          ? String(fallbackColorSeed)
          : String(rowKey)
      }
    />
  );
}

/**
 * Quote / contract / invoice list column: `#10 · Title` on one line (ref link + middot + title).
 * Optional forced line breaks every N words inside the title (quotes/contracts: two-part; invoices: multi-line).
 */
export const JobberTableDocRefTitleCell = ({
  refNumber,
  onRefClick,
  linkColor = "#2563EB",
  title,
  emptyTitleLabel = "Title not available",
  /**
   * When true, the cell only uses the width it needs (narrow tables / schedule rows).
   * Default false keeps full cell width for quote/contract/invoice lists.
   */
  hugContent = false,
  /** Words per line when using forced breaks (default 5). Set 0 to disable. */
  wordsPerLine = 5,
  /**
   * `two-part`: first N words, then remainder (legacy quotes/contracts).
   * `multi-line`: new line every N words (legacy invoices).
   * `none`: no forced breaks.
   */
  titleLineBreakStyle = "two-part",
}) => {
  const raw = title != null ? String(title).trim() : "";
  const displayTitle = raw !== "" ? raw : emptyTitleLabel;

  const titleContent = (() => {
    if (titleLineBreakStyle === "none" || !wordsPerLine || wordsPerLine < 1) {
      return displayTitle;
    }
    const words = displayTitle.trim().split(/\s+/).filter(Boolean);
    if (words.length <= wordsPerLine) {
      return displayTitle;
    }
    if (titleLineBreakStyle === "multi-line") {
      const lines = [];
      for (let i = 0; i < words.length; i += wordsPerLine) {
        lines.push(words.slice(i, i + wordsPerLine).join(" "));
      }
      return (
        <>
          {lines.map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              {idx !== lines.length - 1 ? <br /> : null}
            </React.Fragment>
          ))}
        </>
      );
    }
    // two-part
    return (
      <>
        {words.slice(0, wordsPerLine).join(" ")}
        <br />
        {words.slice(wordsPerLine).join(" ")}
      </>
    );
  })();

  return (
    <Box
      className={[
        "jobber-doc-ref-title-cell",
        hugContent ? "jobber-doc-ref-title-cell--hug" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "center",
        columnGap: "8px",
        rowGap: "4px",
        minWidth: 0,
        maxWidth: "100%",
        width: hugContent ? "auto" : "100%",
        boxSizing: "border-box",
      }}
    >
      <Typography
        component="span"
        onClick={onRefClick}
        sx={{
          color: linkColor,
          fontWeight: 700,
          cursor: onRefClick ? "pointer" : "default",
          textDecoration: "none",
          fontSize: "0.9375rem",
          lineHeight: 1.45,
          flexShrink: 0,
          ...(onRefClick ? { "&:hover": { textDecoration: "underline" } } : {}),
        }}
      >
        #{refNumber ?? "—"}
      </Typography>
      <Typography
        component="span"
        sx={{
          flexShrink: 0,
          color: "text.secondary",
          fontWeight: 400,
          fontSize: "0.9375rem",
          lineHeight: 1,
          userSelect: "none",
        }}
        aria-hidden
      >
        ·
      </Typography>
      <Box
        sx={
          hugContent
            ? { flex: "0 1 auto", minWidth: 0, maxWidth: "100%" }
            : { flex: "1 1 200px", minWidth: 0 }
        }
      >
        <Typography
          component="div"
          sx={{
            color: "text.primary",
            fontWeight: 500,
            fontSize: "0.9375rem",
            lineHeight: 1.45,
            wordBreak: "normal",
            overflowWrap: "break-word",
          }}
        >
          {titleContent}
        </Typography>
      </Box>
    </Box>
  );
};

/** Right-aligned list amount: primary text color, tabular figures (Quotes / Contract totals). */
export const JobberAmountCell = ({ children }) => (
  <Box
    className="jobber-amount-cell"
    sx={{
      textAlign: "right",
      width: "100%",
    }}
  >
    <Typography
      component="span"
      className="jobber-amount-cell__text"
      sx={{
        color: "text.primary",
        fontWeight: 700,
        fontVariantNumeric: "tabular-nums",
        fontSize: "0.9375rem",
      }}
    >
      {children}
    </Typography>
  </Box>
);

const JobberSearch = ({ search, setSearch, placeholder = "Search..." }) => {
  const [inputValue, setInputValue] = useState(search || "");
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  const commitSearch = () => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    setSearch(inputValue);
  };

  const handleSearchKeyDown = (e) => {
    if (e?.key === "Enter") {
      e.preventDefault();
      commitSearch();
    }
  };

  const handleInputChange = (e) => {
    const newValue = e?.target?.value || "";
    setInputValue(newValue);

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const timeout = setTimeout(() => {
      setSearch(newValue);
    }, 500);

    setDebounceTimeout(timeout);
  };

  const handleSearchClick = () => {
    commitSearch();
  };

  useEffect(() => {
    setInputValue(search || "");
  }, [search]);

  useEffect(() => {
    return () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
    };
  }, [debounceTimeout]);

  return (
    <FormGroup className="jobber-search-v2-wrap">
      <SearchInput
        className="jobber-search-v2"
        ariaLabel="search"
        placeholder={placeholder}
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleSearchKeyDown}
        fieldHeight="40px"
        fullWidth
        startAdornment={
          <IconButton
            type="button"
            tabIndex={-1}
            sx={{
              p: "4px",
              mr: "2px",
              flexShrink: 0,
              color: "#9CA3AF",
              borderRadius: "6px",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
                color: "#6B7280",
              },
            }}
            aria-label="Run search"
            onClick={(e) => {
              e.stopPropagation();
              handleSearchClick();
            }}
          >
            <SearchOutlinedIcon
              className="jobber-search-v2__icon"
              sx={{ fontSize: 20 }}
            />
          </IconButton>
        }
        style={{
          borderRadius: "9999px",
          boxShadow: "var(--shadow-sm)",
        }}
        inputProps={{
          className: "jobber-search-v2__input",
          style: { fontSize: "0.875rem" },
        }}
      />
    </FormGroup>
  );
};

const JobberSorting = ({
  dropdownItems,
  onSelect,
  placeholder = "Filter by Status",
  value,
  triggerVariant = "dark", // "dark" = transparent + white border (for dark headers), "light" = white bg + dark border (for light background)
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(value || placeholder);

  // Sync with external value prop if provided
  useEffect(() => {
    if (value !== undefined) {
      setSelectedItem(value);
    }
  }, [value]);

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  const handleSelect = (item) => {
    setSelectedItem(item?.text);
    onSelect(item?.text);
    if (item?.onClick) {
      item?.onClick();
    }
  };

  const triggerStyle =
    triggerVariant === "light"
      ? {
          background: "#F7F8FA",
          border: "1px solid #E5E7EB",
          color: "#374151",
          padding: "0 14px",
          borderRadius: "8px",
          boxShadow: "var(--shadow-sm)",
          height: "40px",
          minHeight: "40px",
          maxHeight: "40px",
          fontWeight: 500,
          fontSize: "0.875rem",
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
          display: "inline-flex",
          alignItems: "center",
          boxSizing: "border-box",
          lineHeight: 1.2,
        }
      : {
          background: "rgba(255,255,255,0.12)",
          border: "1px solid rgba(255,255,255,0.45)",
          color: "#fff",
          minHeight: "40px",
          height: "40px",
          maxHeight: "40px",
          display: "inline-flex",
          alignItems: "center",
          padding: "0 16px",
          borderRadius: "9999px",
          boxSizing: "border-box",
          fontSize: "0.8125rem",
          fontWeight: 600,
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
          lineHeight: 1.2,
        };

  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={toggleDropdown}
      className={
        triggerVariant === "light"
          ? "jobber-toolbar-dropdown jobber-toolbar-dropdown--light"
          : "jobber-toolbar-dropdown"
      }
      style={{ zIndex: 9 }}
    >
      <DropdownToggle
        caret
        className={
          triggerVariant === "light"
            ? "jobber-toolbar-dropdown__toggle jobber-toolbar-dropdown__toggle--light"
            : "jobber-toolbar-dropdown__toggle"
        }
        style={triggerStyle}
      >
        {selectedItem || placeholder}
      </DropdownToggle>
      <DropdownMenu>
        {dropdownItems?.map((item, index) => (
          <DropdownItem
            className="text-blue-color"
            key={index}
            onClick={() => handleSelect(item)}
          >
            {item.text || "text not available"}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};
const JobberSearchDropdown = ({
  aearchdropdownItems,
  onSelect,
  placeholder = "Select searching column",
  triggerVariant = "dark", // match JobberSorting: dark = navy headers, light = JobberListCard
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(placeholder);

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  const handleSelect = (item) => {
    setSelectedItem(item?.text);
    onSelect(item?.text);
    if (item?.onClick) {
      item?.onClick();
    }
  };

  const triggerStyle =
    triggerVariant === "light"
      ? {
          background: "#F7F8FA",
          border: "1px solid #E5E7EB",
          color: "#374151",
          padding: "0 14px",
          borderRadius: "8px",
          boxShadow: "var(--shadow-sm)",
          height: "40px",
          minHeight: "40px",
          maxHeight: "40px",
          fontWeight: 500,
          fontSize: "0.875rem",
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
          display: "inline-flex",
          alignItems: "center",
          boxSizing: "border-box",
          lineHeight: 1.2,
        }
      : {
          background: "rgba(255,255,255,0.12)",
          border: "1px solid rgba(255,255,255,0.45)",
          color: "#fff",
          minHeight: "40px",
          height: "40px",
          maxHeight: "40px",
          display: "inline-flex",
          alignItems: "center",
          padding: "0 16px",
          borderRadius: "9999px",
          boxSizing: "border-box",
          fontSize: "0.8125rem",
          fontWeight: 600,
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
          lineHeight: 1.2,
  };

  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={toggleDropdown}
      className={
        triggerVariant === "light"
          ? "jobber-toolbar-dropdown jobber-toolbar-dropdown--light"
          : "jobber-toolbar-dropdown"
      }
      style={{ zIndex: 9 }}
    >
      <DropdownToggle
        caret
        className={
          triggerVariant === "light"
            ? "jobber-toolbar-dropdown__toggle jobber-toolbar-dropdown__toggle--light"
            : "jobber-toolbar-dropdown__toggle"
        }
        style={triggerStyle}
      >
        {selectedItem || placeholder}
      </DropdownToggle>
      <DropdownMenu>
        {aearchdropdownItems?.map((item, index) => (
          <DropdownItem
            className="text-blue-color"
            key={index}
            onClick={() => handleSelect(item)}
          >
            {item?.text || "text not available"}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

const JobberPagination = ({
  totalData,
  currentData,
  dataPerPage,
  pageItems,
  page,
  setPage,
  setRowsPerPage,
  /** `false` = always Jobber (navy) styling, e.g. Accept Donation admin tables. Omit = donor teal when `userType === "donor"`. */
  donorManagerShell,
}) => {
  const theme = useTheme();
  const { userType: paginationUserType } = useUserType();
  const isDonorPagination =
    donorManagerShell === false
      ? false
      : donorManagerShell === true
        ? true
        : paginationUserType === "donor";
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  const per = Number(dataPerPage) > 0 ? Number(dataPerPage) : 10;
  // Treat null/undefined totalData (initial loading state) as 0 so arithmetic
  // does not produce NaN or render "Showing X-NaN" while the count is in flight.
  const safeTotal = Number.isFinite(Number(totalData)) ? Number(totalData) : 0;

  const handlePrevPage = () => {
    if (page > 0) {
      setPage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (page * per + per < safeTotal) {
      setPage(page + 1);
    }
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    const n = Number(newRowsPerPage) > 0 ? Number(newRowsPerPage) : 10;
    const totalPagesCalc = Math.ceil(safeTotal / n);
    const newPage = Math.min(page, Math.max(0, totalPagesCalc - 1));
    setRowsPerPage(newRowsPerPage);
    setPage(newPage);
  };

  const startItem = safeTotal === 0 ? 0 : page * per + 1;
  const endItem = Math.min((page + 1) * per, safeTotal);

  const totalPages =
    safeTotal === 0 || !per ? 0 : Math.ceil(safeTotal / per);

  const atEnd = page * per + per >= safeTotal || safeTotal === 0;

  const visiblePageIndices = (() => {
    if (totalPages <= 0) return [];
    const maxButtons = 5;
    let start = Math.max(0, page - Math.floor(maxButtons / 2));
    let end = Math.min(totalPages - 1, start + maxButtons - 1);
    if (end - start < maxButtons - 1) {
      start = Math.max(0, end - maxButtons + 1);
    }
    const out = [];
    for (let i = start; i <= end; i += 1) out.push(i);
    return out;
  })();

  return (
    <Box
      className={`jobber-pagination-v2${isDonorPagination ? " jobber-pagination-v2--donor" : ""}`}
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        width: "100%",
        py: 1,
        px: { xs: 1, sm: 2 },
      }}
    >
      <Typography
        component="div"
        className="jobber-pagination-v2__summary"
        sx={{
          fontSize: "0.875rem",
          color: "text.secondary",
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
        }}
      >
        {safeTotal > 0
          ? `Showing ${startItem}–${endItem} of ${safeTotal} results`
          : "Showing 0 of 0 results"}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 1.5,
          marginLeft: "auto",
        }}
      >
      <Dropdown toggle={toggle} isOpen={dropdownOpen} style={{ zIndex: 9 }}>
        <DropdownToggle
          caret
            className="jobber-pagination-v2__rows-toggle"
        >
            {dataPerPage || "—"}
        </DropdownToggle>
        <DropdownMenu>
          {pageItems &&
            pageItems?.map((item, index) => (
              <DropdownItem
                  className="jobber-pagination-v2__rows-item"
                onClick={() => handleRowsPerPageChange(item)}
                key={index}
              >
                  {item || "—"}
              </DropdownItem>
            ))}
        </DropdownMenu>
      </Dropdown>

        <Box
          className="jobber-pagination-v2__nav"
          sx={{ display: "flex", alignItems: "center", gap: 0.75 }}
        >
          <button
            type="button"
            className="jobber-pagination-v2__arrow"
            disabled={page === 0 || safeTotal === 0}
          onClick={handlePrevPage}
            aria-label="Previous page"
          >
            <KeyboardArrowLeftIcon sx={{ fontSize: 22 }} />
          </button>

          {visiblePageIndices.map((pi) => (
            <button
              key={pi}
              type="button"
              className={
                page === pi
                  ? "jobber-pagination-v2__page jobber-pagination-v2__page--active"
                  : "jobber-pagination-v2__page"
              }
              onClick={() => setPage(pi)}
            >
              {pi + 1}
            </button>
          ))}

          <button
            type="button"
            className="jobber-pagination-v2__arrow"
            disabled={atEnd}
          onClick={handleNextPage}
            aria-label="Next page"
          >
            <ChevronRightIcon sx={{ fontSize: 22 }} />
          </button>
        </Box>
      </Box>
    </Box>
  );
};

/**
 * Shared list shell: card + toolbar (title, optional Add action, filters/search) + table body + footer.
 * Pass page-specific `addButton` for dynamic labels (e.g. "Add Customer", "Add materials & labor").
 */
const JobberListCard = ({
  title,
  /** Total count shown after title as "n total" (muted, like "10 total") */
  totalCount,
  toolbar,
  addButton = null,
  children,
  footer,
  loader = false,
  loadingContent = null,
  /** Admin donation-company donor list: use spinner body, not table skeleton */
  isDonationMode = false,
}) => {
  const listLocation = useLocation();
  const { userType: listUserType, isDonor: listIsDonor } = useUserType();
  const listPath = listLocation?.pathname || "";
  const donorListUsesSpinner =
    isDonationMode ||
    listIsDonor ||
    listUserType === "donor" ||
    listPath.includes("/donors") ||
    listPath.includes("/donordetails");

  const insetTableLoaderActive = Boolean(loader) && loadingContent == null;

  const {
    label: addLabel,
    onClick: addOnClick,
    show: addShow,
    isDonationMode: addIsDonationMode,
    className: addClassName,
    hidePlusIcon,
    ...addButtonRest
  } = addButton || {};

  const showAdd =
    addButton &&
    addLabel &&
    typeof addOnClick === "function" &&
    (addShow === undefined || addShow === true);

  const addCtaClassName = [
    addIsDonationMode
      ? "jobber-list-card__cta jobber-list-card__cta--donor jobber-btn jobber-btn--donor-primary jobber-btn--md"
      : "jobber-list-card__cta jobber-btn jobber-btn--primary jobber-btn--md",
    addClassName,
  ]
    .filter(Boolean)
    .join(" ")
    .trim();

  const titleNode =
    totalCount !== undefined && totalCount !== null ? (
      <>
        <span className="jobber-list-card__title-main">{title}</span>
        <span className="jobber-list-card__title-count">
          {typeof totalCount === "number"
            ? totalCount.toLocaleString("en-US")
            : totalCount}{" "}
          total
        </span>
      </>
    ) : (
      <span className="jobber-list-card__title-main">{title}</span>
    );

  return (
    <Grid
      className="mb-3 jobber-list-card-wrap"
      sx={{
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
    >
      <Card
        className="jobber-list-card"
        style={{
          width: "100%",
          maxWidth: "100%",
          boxSizing: "border-box",
          borderRadius: 0,
          border: "1px solid #E5E7EB",
          padding: 0,
          background: "#FFFFFF",
          boxShadow: "var(--shadow-md)",
        }}
      >
        <CardHeader
          className="d-flex justify-content-between align-items-center flex-wrap gap-2 jobber-list-card__header customerList_searchbar customersAddCustomers"
          style={{
            background: "#FFFFFF",
            borderBottom: "1px solid #E5E7EB",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            padding: "16px 20px",
          }}
        >
          <Typography
            component="div"
            className="customerList_head heading-five tableNameHead jobber-list-card__title"
          >
            {titleNode}
          </Typography>
          <Grid
            className="d-flex gap-2 align-items-center flex-wrap customersearch customer_searchBar searchBarOfTable jobber-list-card__toolbar"
            style={{ marginLeft: "auto", justifyContent: "flex-end" }}
          >
            {toolbar}
            {showAdd && (
              <BlueButton
                label={
                  hidePlusIcon ? (
                    addLabel
                  ) : (
                    <span className="jobber-list-card__cta-label">
                      <AddIcon
                        className="jobber-list-card__cta-plus"
                        fontSize="small"
                        aria-hidden
                      />
                      {addLabel}
                    </span>
                  )
                }
                onClick={addOnClick}
                isDonationMode={addIsDonationMode}
                className={addCtaClassName || undefined}
                {...addButtonRest}
              />
            )}
      </Grid>
        </CardHeader>
        <JobberListCardLoaderContext.Provider
          value={{
            listLoading: insetTableLoaderActive,
            listLoadingUseSpinner: donorListUsesSpinner,
          }}
        >
          <CardBody style={{ padding: 0 }}>
            {loader && loadingContent != null ? loadingContent : children}
          </CardBody>
        </JobberListCardLoaderContext.Provider>
        <CardFooter
          className="jobber-list-card__footer"
          style={{
            background: "#FFFFFF",
            borderTop: "1px solid #E5E7EB",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            padding: "12px 16px",
          }}
        >
          {footer}
        </CardFooter>
      </Card>
    </Grid>
  );
};

let globalNotificationRefresh = null;

const MainNav = ({
  setIsSidebarDisplay,
  isSidebarDisplay,
  isSidebarClosed,
  layout = "",
}) => {
  const cdnUrl = import.meta.env.VITE_BASE_API;
  const location = useLocation();
  const navigate = useNavigate();
  const { CompanyUrl } = useParams();
  
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(max-width:991px)");
  const isSmallDesktop = useMediaQuery("(max-width:1279px)");
  const isMediumDesktop = useMediaQuery("(max-width:1439px)");
  const isLargeScreen = useMediaQuery("(min-width:1440px)");
  const isExtraSmall = useMediaQuery("(max-width:575px)");
  const isSmallMobile = useMediaQuery("(max-width:424px)");
  
  const isMediumScreen = isMobile;
  
  const { userType } = useUserType();
  const isDonationMode = userType === "donor";
  const theme = useTheme();
  const { darkMode: adminDarkMode } = useAdminDarkMode();
  const { darkMode: customerDarkMode } = useCustomerDarkMode();
  const [data, setData] = useState({});
  const [localNotificationCount, setLocalNotificationCount] = useState(0);
  const [recountNotification, setRecountNotification] = useState(false);
  const [isNotify, setIsNotify] = useState(false);
  const [openCustome, setOpenCustome] = useState(false);
  const [navigateItems, setNaviagateItems] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [notificationPagination, setNotificationPagination] = useState({
    totalCount: 0,
    totalAllNotifications: 0,
    totalPages: 1,
    currentPage: 1,
  });
  const [loader, setLoader] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [lastFetchTime, setLastFetchTime] = useState(0);
  const [tokenDecode, setTokenDecode] = useState({});
  const [isAIChatOpen, setIsAIChatOpen] = useState(false);
  const [profileImageLoadError, setProfileImageLoadError] = useState(false);
  const DEFAULT_SALES_PHONE = "(888) 272-4660";
  const DEFAULT_SUPPORT_PHONE = "(302) 455-2432";
  
  const [supportSettings, setSupportSettings] = useState({ 
    SalesPhone: DEFAULT_SALES_PHONE, 
    SupportPhone: DEFAULT_SUPPORT_PHONE 
  });
  
  const [isSwitchOn, setisSwitchOn] = React.useState(() => {
    const baseState = {
      invoices: true,
      customers: true,
      quotes: true,
      contracts: true,
      workers: true,
      donors: true,
      donations: true,
      AppointmentConfirmNotification: true,
      QuoteChangeRequestNotification: true,
      ProductAndServiceCreateNotification: true,
      QuoteConfirmNotification: true,
      contractConfirm: true,
      ManageAccountNotification: true,
      ManageTempletes: true,
      RecurringChargeNotification: true,
      RecurringPaymentNotification: true,
      AddVisitNotifications: true,
      Quotesignature: true,
      OneTimeChargeNotification: true,
      DonorCreateNotification: true,
      DonorPaymentNotification: true,
    };

    if (isDonationMode) {
      return {
        ...baseState,
        invoices: false,
        quotes: false,
        contracts: false,
        workers: false,
        AppointmentConfirmNotification: false,
        QuoteChangeRequestNotification: false,
        ProductAndServiceCreateNotification: false,
        QuoteConfirmNotification: false,
        contractConfirm: false,
        AddVisitNotifications: false,
        Quotesignature: false,
        customers: true,
        donors: true,
        donations: true,
        ManageAccountNotification: true,
        ManageTempletes: true,
        RecurringChargeNotification: true,
        RecurringPaymentNotification: true,
        OneTimeChargeNotification: true,
        DonorCreateNotification: true,
        DonorPaymentNotification: true,
      };
    }

    return baseState;
  });

  const notificationCount = useCountNotifications();
  
  useEffect(() => {
    setLocalNotificationCount(notificationCount);
  }, [notificationCount]);

  const handleProfileImageError = () => {
    console.warn("Profile image failed to load:", data?.ProfileImage);
    setProfileImageLoadError(true);
  };

  const formatName = (firstName, lastName, fullName) => {
    if (firstName && (lastName || fullName)) {
      const last = lastName || fullName || "";
      return `${firstName} ${last}`.trim();
    }
    return firstName || fullName || "";
  };

  const getInitials = (firstName, lastName, fullName, ownerName) => {
    // Trim all inputs first
    const trimmedFirstName = firstName?.trim() || "";
    const trimmedLastName = lastName?.trim() || "";
    const trimmedFullName = fullName?.trim() || "";
    const trimmedOwnerName = ownerName?.trim() || "";
    
    // Check if fullName is a valid name (not "undefined undefined" or similar invalid strings)
    const isValidFullName = trimmedFullName && 
      !trimmedFullName.toLowerCase().includes("undefined") &&
      trimmedFullName.split(" ").filter(part => part.length > 0 && part.toLowerCase() !== "undefined").length > 0;
    
    // Priority 1: If firstName and lastName both exist, use them (most reliable for Customer/Worker/Donor)
    if (trimmedFirstName && trimmedLastName) {
      return `${trimmedFirstName.charAt(0).toUpperCase()}${trimmedLastName.charAt(0).toUpperCase()}`;
    }
    
    // Priority 2: If fullName exists and is valid, use it
    if (isValidFullName) {
      const initials = trimmedFullName
        .split(" ")
        .filter(part => part.length > 0 && part.toLowerCase() !== "undefined")
        .map((part) => part.charAt(0).toUpperCase())
        .join("")
        .substring(0, 2);
      if (initials) return initials;
    }
    
    // Priority 3: If only firstName exists, use first two characters
    if (trimmedFirstName) {
      return trimmedFirstName.substring(0, 2).toUpperCase();
    }
    
    // Priority 4: Check ownerName as fallback (for Admin/Company roles)
    if (trimmedOwnerName) {
      const initials = trimmedOwnerName
        .split(" ")
        .filter(part => part.length > 0)
        .map((part) => part.charAt(0).toUpperCase())
        .join("")
        .substring(0, 2);
      if (initials) return initials;
    }
    
    return "";
  };

  const fetchDatas = async () => {
    try {
      const res = await handleAuth(navigate, location);
      setTokenDecode(res?.data);
      setData(res?.data);
      setProfileImageLoadError(false);
      
      // If user is Customer, Worker, or Donor, fetch profile separately to get ProfileImage
      const role = res?.data?.data?.Role ?? res?.data?.Role;
      const customerId = getItem("CustomerId");
      const workerId = getItem("worker_id");
      const donorId = getItem("DonorId");
      
      if (role === "Customer" && customerId) {
        try {
          const profileRes = await AxiosInstance.get(`/v1/customer/profile/${customerId}`);
          if (profileRes?.data?.success && profileRes?.data?.data?.userProfile) {
            const profileData = profileRes?.data?.data?.userProfile;
            const profileImage = profileData?.ProfileImage?.trim() || "";
            const firstName = profileData?.FirstName?.trim() || "";
            const lastName = profileData?.LastName?.trim() || "";
            // Reset profileImageLoadError if ProfileImage is empty
            if (!profileImage) {
              setProfileImageLoadError(false);
            }
            setData(prevData => ({
              ...prevData,
              ProfileImage: profileImage,
              FirstName: firstName || prevData?.FirstName || "",
              LastName: lastName || prevData?.LastName || "",
            }));
          }
        } catch (error) {
          console.error("Error fetching customer profile:", error);
        }
      } else if (role === "Worker" && workerId) {
        try {
          const profileRes = await AxiosInstance.get(`/v1/worker/profile/${workerId}`);
          if (profileRes?.data?.success && profileRes?.data?.data?.userProfile) {
            const profileData = profileRes?.data?.data?.userProfile;
            const profileImage = profileData?.ProfileImage?.trim() || "";
            const firstName = profileData?.FirstName?.trim() || "";
            const lastName = profileData?.LastName?.trim() || "";
            // Reset profileImageLoadError if ProfileImage is empty
            if (!profileImage) {
              setProfileImageLoadError(false);
            }
            setData(prevData => ({
              ...prevData,
              ProfileImage: profileImage,
              FirstName: firstName || prevData?.FirstName || "",
              LastName: lastName || prevData?.LastName || "",
            }));
          }
        } catch (error) {
          console.error("Error fetching worker profile:", error);
        }
      } else if (role === "Donor" && donorId) {
        try {
          const profileRes = await AxiosInstance.get(`/v1/customer/profile/${donorId}`);
          if (profileRes?.data?.success && profileRes?.data?.data?.userProfile) {
            const profileData = profileRes?.data?.data?.userProfile;
            const profileImage = profileData?.ProfileImage?.trim() || "";
            const firstName = profileData?.FirstName?.trim() || "";
            const lastName = profileData?.LastName?.trim() || "";
            // Reset profileImageLoadError if ProfileImage is empty
            if (!profileImage) {
              setProfileImageLoadError(false);
            }
            setData(prevData => ({
              ...prevData,
              ProfileImage: profileImage,
              FirstName: firstName || prevData?.FirstName || "",
              LastName: lastName || prevData?.LastName || "",
            }));
          }
        } catch (error) {
          console.error("Error fetching donor profile:", error);
        }
      }
      
      fetchSupportSettings();
    } catch (error) {}
  };

  const fetchSupportSettings = async () => {
    try {
      // JOB-3419 follow-up: /super-admin/* endpoints are Superadmin-only.
      // The sidebar nav is shared across all roles, so guard the call here
      // the same way dashboardSupportPhones.js does — fall back to the
      // hard-coded defaults for tenant Company / Worker / Customer / Donor
      // sessions so they never make this request.
      try {
        const tok = getItem("adminToken");
        const role = tok ? jwtDecode(tok)?.Role : null;
        if (role !== "Admin") {
          setSupportSettings({
            SalesPhone: DEFAULT_SALES_PHONE,
            SupportPhone: DEFAULT_SUPPORT_PHONE,
          });
          return;
        }
      } catch {
        setSupportSettings({
          SalesPhone: DEFAULT_SALES_PHONE,
          SupportPhone: DEFAULT_SUPPORT_PHONE,
        });
        return;
      }
      const baseUrl = import.meta.env.VITE_BASE_API;
      const response = await AxiosInstance.get(
        `/v1/super-admin/support-settings`
      );
      if (response?.data?.statusCode === 200) {
        const data = response?.data?.data || {};
        setSupportSettings({
          SalesPhone: data.SalesPhone || DEFAULT_SALES_PHONE,
          SupportPhone: data.SupportPhone || DEFAULT_SUPPORT_PHONE,
        });
      } else {
        setSupportSettings({
          SalesPhone: DEFAULT_SALES_PHONE,
          SupportPhone: DEFAULT_SUPPORT_PHONE,
        });
      }
    } catch (error) {
      console.error("Error fetching support settings:", error);
      setSupportSettings({
        SalesPhone: DEFAULT_SALES_PHONE,
        SupportPhone: DEFAULT_SUPPORT_PHONE,
      });
    }
  };

  const formatPhoneForDisplay = (phone) => {
    if (!phone) return "";
    const digitsOnly = phone.replace(/\D/g, "");
    if (digitsOnly.length === 10) {
      return `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`;
    }
    if (phone.match(/^\(\d{3}\)\s\d{3}-\d{4}$/)) {
      return phone;
    }
    return phone;
  };

  const formatPhoneForTelLink = (phone) => {
    if (!phone) return "";
    // Remove all non-digit characters for tel: link
    const digitsOnly = phone.replace(/\D/g, "");
    // If it's a 10-digit number, add +1 for US numbers
    if (digitsOnly.length === 10) {
      return `+1${digitsOnly}`;
    }
    // If it already has country code or other format, return as is
    return digitsOnly;
  };

  const useRemoveToken = async () => {
    clear();
    navigate("/auth/login");
  };

  const handleNotificationsClick = () => {
    setIsNotify(true);
    setLoader(true);
    
    setTimeout(() => {
      fetchNotifications(true);
    }, 0);
  };
  const handleCloseNotifications = () => {
    setIsNotify(false);
    setLoader(false);
  };

  const findMatchingNames = () => {
    const parts = location?.pathname?.split("/").filter(Boolean);
    const lastIndex = parts.lastIndexOf(CompanyUrl);

    let cleanPath = "/";
    if (lastIndex !== -1 && parts.length > lastIndex + 1) {
      cleanPath += parts[lastIndex] + "/" + parts[lastIndex + 1];
    }

    let pathname = "";
    if (`${location?.pathname.split("/")[2]}` == "staff-member") {
      pathname = "/staff-member";
    } else if (`${location?.pathname.split("/")[2]}` == "customers") {
      pathname = "/customers";
    } else if (`${location?.pathname.split("/")[2]}` == "donors") {
      pathname = "/donors";
    } else {
      pathname = "";
    }

    let locationPath = location?.state?.navigats;
    if (locationPath) {
      locationPath = locationPath.filter(
        (item) => item !== "customers" && item !== "staff-member"
      );
    }

    let part = "";
    const lastNav = locationPath && locationPath[locationPath.length - 1];
    const isFullReportPath =
      typeof lastNav === "string" &&
      (lastNav.startsWith("/company-reports/") ||
        lastNav.startsWith("/worker-reports/") ||
        lastNav.startsWith("/reports/"));
    if (locationPath && lastNav?.includes("/") && !isFullReportPath) {
      part = lastNav.split("/");
      part = part[part.length - 1];
      locationPath[locationPath.length - 1] = "/" + part;
    } else if (isFullReportPath) {
      part = lastNav.split("/")[lastNav.split("/").length - 1];
    }

    locationPath = [...new Set(locationPath)];

    let matchingNames = [];
    if (
      locationPath &&
      part ===
        location?.pathname.split("/")[location?.pathname.split("/").length - 1]
    ) {
      if (!locationPath?.includes("/index")) {
        locationPath.unshift("/index");
      }

      locationPath.forEach((item) => {
        routes?.forEach((route) => {
          if (
            route?.isCollapse &&
            route?.children &&
            route?.layout === `/:CompanyUrl${pathname}` &&
            !location?.pathname?.includes(`superadmin`)
          ) {
            route?.children?.forEach((child) => {
              if (child?.path === item) {
                matchingNames = [...matchingNames, child];
              }
            });
          } else if (
            !route?.isCollapse &&
            route?.layout === `/:CompanyUrl${pathname}` &&
            !location?.pathname?.includes(`superadmin`)
          ) {
            if (route?.path === item) {
              matchingNames = [...matchingNames, route];
            }
          }
          if (location?.pathname?.includes("superadmin")) {
            if (
              route?.isCollapse &&
              route?.children &&
              route?.layout === `/superadmin`
            ) {
              route?.children?.forEach((child) => {
                if (child?.path === item) {
                  matchingNames = [...matchingNames, child];
                }
              });
            } else if (!route?.isCollapse && route?.layout === `/superadmin`) {
              if (route?.path === item) {
                matchingNames = [...matchingNames, route];
              }
            }
          }
        });
      });

      setNaviagateItems(matchingNames);
    } else {
      const pathSegments = location?.pathname?.split("/").filter(Boolean) || [];
      const companyIdx = pathSegments.indexOf(CompanyUrl);
      const afterCompany = companyIdx >= 0 ? pathSegments.slice(companyIdx + 1) : [];
      const fullReportPath = afterCompany.length > 0 ? "/" + afterCompany.join("/") : "";

      const isCompanyOrWorkerReport =
        (fullReportPath.startsWith("/company-reports/") || fullReportPath.startsWith("/worker-reports/")) &&
        fullReportPath.length > 1;
      const isDonorReport = fullReportPath.startsWith("/reports/") && fullReportPath.length > 1;

      if (isCompanyOrWorkerReport || isDonorReport) {
        const reportRoute = routes?.find(
          (r) =>
            r.path === fullReportPath &&
            (r.layout === "/:CompanyUrl" || r.layout === "/:CompanyUrl/staff-member")
        );
        const reportsParentPath = fullReportPath.startsWith("/worker-reports")
          ? "/worker-reports"
          : fullReportPath.startsWith("/reports/")
          ? "/reports"
          : "/company-reports";
        const reportsParent = routes?.find(
          (r) => r.path === reportsParentPath && (r.layout === "/:CompanyUrl" || r.layout === "/:CompanyUrl/staff-member")
        );
        if (reportRoute && reportsParent) {
          setNaviagateItems([
            { name: "Home", path: "/index" },
            { name: "Reports", path: reportsParent.path },
            { name: reportRoute.name, path: reportRoute.path },
          ]);
          return;
        }
      }

      let path =
        location?.pathname?.split("/")[
          location?.pathname?.split("/").length - 1
        ];
      path = [path];
      if (path == "index") {
        if (location?.state?.breadcrumbs && location.state.breadcrumbs.length > 0) {
          const homeRoute = routes?.find(route => 
            route?.path === "/index" && 
            (route?.layout === `/:CompanyUrl` || route?.layout === `/:CompanyUrl${pathname}`)
          );
          if (homeRoute) {
            setNaviagateItems([homeRoute]);
          } else {
            setNaviagateItems([{ name: "Home", path: "/index" }]);
          }
        }
        return;
      }

      path = path.filter(
        (item) => item !== "customers" && item !== "staff-member" && item !== ""
      );

      const newNavigats = ["/index", `/${path?.join("/")}`];

      newNavigats.forEach((item) => {
        routes?.forEach((route) => {
          if (
            route?.isCollapse &&
            route?.children &&
            route?.layout === `/:CompanyUrl${pathname}` &&
            !location?.pathname?.includes(`superadmin`)
          ) {
            route?.children?.forEach((child) => {
              if (child?.path === item) {
                matchingNames = [...matchingNames, child];
              }
            });
          } else if (
            !route?.isCollapse &&
            route?.layout === `/:CompanyUrl${pathname}` &&
            !location?.pathname?.includes(`superadmin`)
          ) {
            if (route?.path === item) {
              matchingNames = [...matchingNames, route];
            }
          }
          if (location?.pathname?.includes("superadmin")) {
            if (
              route?.isCollapse &&
              route?.children &&
              route?.layout === `/superadmin`
            ) {
              route?.children?.forEach((child) => {
                if (child?.path === item) {
                  matchingNames = [...matchingNames, child];
                }
              });
            } else if (!route?.isCollapse && route?.layout === `/superadmin`) {
              if (route?.path === item) {
                matchingNames = [...matchingNames, route];
              }
            }
          }
        });
      });

      setNaviagateItems(matchingNames);
    }

    return matchingNames;
  };
  useEffect(() => {
    findMatchingNames();
  }, [location.pathname]);

  const handleSwitchChange = (event) => {
    setisSwitchOn((pre) => {
      return { ...pre, [event?.target?.name]: event?.target?.checked };
    });
  };

  async function fetchNotifications(page = 1, limit = 100, search = "", startDate = "", endDate = "", force = false) {
    const currentTime = Date.now();

    if (isFetching && !force) {
      return;
    }

    if (!force && currentTime - lastFetchTime < 1000) {
      return;
    }

    setIsFetching(true);
    setLoader(true);
    setLastFetchTime(currentTime);

    try {
      // Build query parameters
      const params = new URLSearchParams();
      params.append('page', page.toString());
      params.append('limit', limit.toString());
      if (search) params.append('search', search);
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);

      const response = await AxiosInstance.get(`/v1/notification?${params.toString()}`);
      if (response?.data.statusCode === 200) {
        const notifications = response?.data?.notifications;
        
        // Update local notification count from API response
        const unreadCount = response?.data?.count || 0;
        setLocalNotificationCount(unreadCount);
        
        // Store pagination metadata
        setNotificationPagination({
          totalCount: response?.data?.totalCount || 0,
          totalAllNotifications: response?.data?.totalAllNotifications || 0,
          totalPages: response?.data?.totalPages || 1,
          currentPage: response?.data?.currentPage || 1,
        });

        // Apply switch filters (client-side filtering for notification types)
        const switchFilteredNotifications = notifications?.filter(
          (notification) => {
            if (!isSwitchOn) return true;
            if (
              notification?.CreatedBy.includes("Donor-Creation") &&
              !isSwitchOn?.DonorCreateNotification
            )
              return false;
            if (
              notification?.CreatedBy.includes("Payment") &&
              !isSwitchOn?.DonorPaymentNotification
            )
              return false;
            if (
              notification?.CreatedBy.includes("Account-Creation") &&
              !isSwitchOn?.ManageAccountNotification
            )
              return false;
            if (
              notification?.CreatedBy.includes("Template-Creation") &&
              !isSwitchOn?.ManageTempletes
            )
              return false;
            if (
              notification?.CreatedBy.includes("RecurringCharge-Creation") &&
              !isSwitchOn?.RecurringChargeNotification
            )
              return false;
            if (
              notification?.CreatedBy.includes("RecurringPayment-Creation") &&
              !isSwitchOn?.RecurringPaymentNotification
            )
              return false;
            if (
              notification?.CreatedBy === "Payment" &&
              !isSwitchOn?.OneTimeChargeNotification
            )
              return false;

            if (isDonationMode) {
              if (
                notification?.CreatedBy === "Donor-Creation" &&
                isSwitchOn?.donors === false
              )
                return false;
              if (
                notification?.Activity?.description.includes("Donate") &&
                isSwitchOn?.donations === false
              )
                return false;
              if (
                notification?.CreatedBy === "Customer-Creation" &&
                isSwitchOn?.customers === false
              )
                return false;

              return true;
            } else {
              if (
                notification?.CreatedBy.includes("Visit-Confirmed") &&
                !isSwitchOn?.AppointmentConfirmNotification
              )
                return false;
              if (
                notification?.CreatedBy === "Quote-ChangeRequested" &&
                !isSwitchOn?.QuoteChangeRequestNotification
              )
                return false;
              if (
                notification?.CreatedBy === "MaterialsAndLabor-Creation" &&
                !isSwitchOn?.ProductAndServiceCreateNotification
              )
                return false;
              if (
                notification?.CreatedBy === "Quote-Approved" &&
                !isSwitchOn?.QuoteConfirmNotification
              )
                return false;
              if (
                notification?.CreatedBy === "Visit-Creation" &&
                !isSwitchOn?.AddVisitNotifications
              )
                return false;
              if (
                notification?.CreatedBy === "SignatureRequest-Creation" &&
                !isSwitchOn?.Quotesignature
              )
                return false;

              if (
                notification?.CreatedBy.includes("Quote") &&
                !isSwitchOn?.quotes
              )
                return false;
              if (
                notification?.CreatedBy.includes("Contract") &&
                !isSwitchOn?.contracts
              )
                return false;
              if (
                notification?.CreatedBy.includes("Invoice") &&
                !isSwitchOn?.invoices
              )
                return false;
              if (
                notification?.CreatedBy.includes("Worker") &&
                !isSwitchOn?.workers
              )
                return false;
              if (
                notification?.CreatedBy.includes("Customer") &&
                !isSwitchOn?.customers
              )
                return false;
            }

            return true;
          }
        );
     
        const uniqueNotifications = [];
        const seenNotifications = new Set();

        // Backend already sorts by createdAt, but we need to maintain order after client-side filtering
        // Sort by createdAt (backend field) to ensure newest first
        const sortedNotifications = switchFilteredNotifications?.sort(
          (a, b) => {
            const dateA = new Date(a.createdAt || a.AddedAt || 0);
            const dateB = new Date(b.createdAt || b.AddedAt || 0);
            return dateB - dateA; // Descending order (newest first)
          }
        );
        setNotifications(sortedNotifications || []);
      } else {
        setNotifications([]);
        setLocalNotificationCount(0);
      }
    } catch (error) {
      setNotifications([]);
      setLocalNotificationCount(0);
    } finally {
      setLoader(false);
      setIsFetching(false);
    }
  }

  useEffect(() => {
    fetchDatas();
    const handleClickOutside = (event) => {
      if (event?.target?.closest(".notification-bar") === null) {
        setIsNotify(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    globalNotificationRefresh = () => {
      if (isNotify) {
        // Only refresh if Activity Feed is open
        fetchNotifications(1, 100, "", "", "", true);
      }
    };

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      globalNotificationRefresh = null;
    };
  }, [navigate]);

  useEffect(() => {
    if (location.pathname.includes("/index") || location.pathname === "/superadmin/index" || location.pathname.includes("/profile")) {
      fetchDatas();
    }
  }, [location.pathname]);

  useEffect(() => {
  }, []);

  // Fetch notifications when notification panel opens
  useEffect(() => {
    if (isNotify) {
      fetchNotifications(1, 100, "", "", "", true);
    }
  }, [isNotify]);


  // Don't fetch notifications when donation mode changes
  // Only fetch when Activity Feed is opened
  // useEffect(() => {
  //   fetchNotifications(1, 10, "", "", "", true);
  // }, [isDonationMode]);

  useEffect(() => {
    if (recountNotification) {
      setRecountNotification(false);
      setLocalNotificationCount(0);
    }
  }, [recountNotification]);

  function viewAll() {
    setRecountNotification(true);
    setLocalNotificationCount(0);
    setTimeout(() => {
      fetchNotifications(1, 100, "", "", "", false);
    }, 500);
  }

  const handleAiChatClick = () => {
    setIsAIChatOpen(!isAIChatOpen);
  };

  const handleAIChatClose = () => {
    setIsAIChatOpen(false);
  };

  const authNav = useMemo(() => {
    const td = tokenDecode;
    const inner = td?.data;
    if (inner && typeof inner === "object" && inner.Role != null) {
      return inner;
    }
    if (td && typeof td === "object" && td.Role != null) {
      return td;
    }
    return {};
  }, [tokenDecode]);

  const portalThemePath = useMemo(() => {
    if (layout === "/:CompanyUrl/customers" && CompanyUrl) {
      return `/${CompanyUrl}/customers/settings/theme`;
    }
    if (layout === "/:CompanyUrl/staff-member" && CompanyUrl) {
      return `/${CompanyUrl}/staff-member/settings/theme`;
    }
    if (layout === "/superadmin") {
      return "/superadmin/settings/theme";
    }
    return null;
  }, [layout, CompanyUrl]);

  const useCjNavStyle =
    !isDonationMode &&
    [
      "/:CompanyUrl",
      "/:CompanyUrl/staff-member",
      "/:CompanyUrl/customers",
      "/superadmin",
    ].includes(layout);

  const isCjPortalRailLayout =
    layout === "/:CompanyUrl/customers" ||
    layout === "/:CompanyUrl/staff-member";

  const showSalesSupport =
    (!isMobile && useCjNavStyle) ||
    (!useCjNavStyle && authNav?.Role === "Company");

  const showAiInNav = !isMobile && !useCjNavStyle;

  /** Global navbar search: company portal (CJ) roles + platform Admin — not donor. */
  const showGlobalSearchBar =
    !isDonationMode &&
    !isMobile &&
    ((useCjNavStyle &&
      ["Company", "Worker", "Customer"].includes(authNav?.Role ?? "")) ||
      (layout === "/superadmin" && authNav?.Role === "Admin"));

  const cjNavCompanyDesktopRef = useRef(null);
  const cjNavCompanyMobileRef = useRef(null);
  const [cjNavCompanyNameTruncated, setCjNavCompanyNameTruncated] =
    useState(false);
  const cjNavCompanyDisplayName = authNav?.CompanyName || "Company";

  const updateCjNavCompanyTruncation = useCallback(() => {
    const isVisible = (el) => {
      if (!el) return false;
      const st = window.getComputedStyle(el);
      if (st.display === "none" || st.visibility === "hidden") return false;
      return el.getClientRects().length > 0;
    };
    const d = cjNavCompanyDesktopRef.current;
    const m = cjNavCompanyMobileRef.current;
    let truncated = false;
    if (isVisible(d) && d.scrollWidth > d.clientWidth + 1) truncated = true;
    if (isVisible(m) && m.scrollWidth > m.clientWidth + 1) truncated = true;
    setCjNavCompanyNameTruncated(truncated);
  }, []);

  useLayoutEffect(() => {
    if (!useCjNavStyle) return undefined;
    updateCjNavCompanyTruncation();
    const d = cjNavCompanyDesktopRef.current;
    const m = cjNavCompanyMobileRef.current;
    const nodes = [d, m].filter(Boolean);
    if (nodes.length === 0 || typeof ResizeObserver === "undefined") {
      return undefined;
    }
    const ro = new ResizeObserver(() => updateCjNavCompanyTruncation());
    nodes.forEach((n) => ro.observe(n));
    return () => ro.disconnect();
  }, [
    useCjNavStyle,
    cjNavCompanyDisplayName,
    isTablet,
    isMobile,
    isSidebarClosed,
    updateCjNavCompanyTruncation,
  ]);

  const [globalSearchQuery, setGlobalSearchQuery] = useState("");
  const [globalSearchResults, setGlobalSearchResults] = useState([]);
  const [globalSearchOpen, setGlobalSearchOpen] = useState(false);
  const [globalSearchLoading, setGlobalSearchLoading] = useState(false);
  const globalSearchAbortRef = useRef(null);
  const [globalSearchAnchorEl, setGlobalSearchAnchorEl] = useState(null);

  useEffect(() => {
    if (!showGlobalSearchBar) return undefined;
    const tq = globalSearchQuery.trim();
    const allowShortNumeric = /^\d+$/.test(tq) && tq.length >= 1;
    if (tq.length < 2 && !allowShortNumeric) {
      setGlobalSearchResults([]);
      setGlobalSearchOpen(false);
      return undefined;
    }
    const handle = setTimeout(() => {
      globalSearchAbortRef.current?.abort();
      const ac = new AbortController();
      globalSearchAbortRef.current = ac;
      setGlobalSearchLoading(true);
      AxiosInstance.get("/v1/search/global", {
        params: { q: globalSearchQuery.trim(), limit: 40 },
        signal: ac.signal,
      })
        .then((res) => {
          const rows = res?.data?.data?.results ?? [];
          setGlobalSearchResults(rows);
          setGlobalSearchOpen(true);
        })
        .catch((err) => {
          if (err?.code !== "ERR_CANCELED" && err?.name !== "CanceledError") {
            setGlobalSearchResults([]);
          }
        })
        .finally(() => setGlobalSearchLoading(false));
    }, 300);
    return () => clearTimeout(handle);
  }, [globalSearchQuery, showGlobalSearchBar]);

  const openGlobalSearchResult = useCallback(
    (item) => {
      if (!item?.kind) return;
      const slug = item.companyUrl || CompanyUrl || "";
      const isStaff = location.pathname.includes("/staff-member");
      const isCustomerPortal = location.pathname.includes("/customers");

      setGlobalSearchOpen(false);
      setGlobalSearchQuery("");

      if (item.kind === "company") {
        navigate("/superadmin/company-detail", {
          state: {
            id: item.id,
            navigats: ["/index", "/company", "/company-detail"],
          },
        });
        return;
      }

      if (item.kind === "page") {
        if (item.forSuperAdmin) {
          navigate(item.path || "/superadmin/index", {
            state: { navigats: item.navigats || [] },
          });
          return;
        }
        if (!slug) return;
        navigate(`/${slug}${item.path}`, {
          state: { navigats: item.navigats || [] },
        });
        return;
      }

      if (item.kind === "tax" || item.kind === "template" || item.kind === "material") {
        if (!slug) return;
        const suffix = item.path || "/taxes";
        navigate(`/${slug}${suffix}`, {
          state: { navigats: item.navigats || [] },
        });
        return;
      }

      if (!slug) return;

      const base = `/${slug}`;

      if (item.kind === "quote") {
        const path = isCustomerPortal
          ? `${base}/customers/quotes-details`
          : isStaff
          ? `${base}/staff-member/worker-quotes-details`
          : `${base}/quotes-detail`;
        const nav = isCustomerPortal
          ? ["/index", "/quotes", "/quotes-details"]
          : isStaff
          ? [
              "/index",
              "/staff-member",
              "/worker-quote",
              "/worker-quotes-details",
            ]
          : ["/index", "/quotes", "/quotes-detail"];
        navigate(path, { state: { id: item.id, navigats: nav } });
        return;
      }

      if (item.kind === "invoice") {
        const path = isCustomerPortal
          ? `${base}/customers/invoice-details`
          : isStaff
          ? `${base}/staff-member/worker-invoice-detail`
          : `${base}/invoice-details`;
        const nav = isCustomerPortal
          ? ["/index", "/invoice", "/invoice-details"]
          : isStaff
          ? [
              "/index",
              "/staff-member",
              "/worker-invoice",
              "/worker-invoice-detail",
            ]
          : ["/index", "/invoice", "/invoice-details"];
        navigate(path, { state: { id: item.id, navigats: nav } });
        return;
      }

      if (item.kind === "contract") {
        const path = isCustomerPortal
          ? `${base}/customers/contract-details`
          : isStaff
          ? `${base}/staff-member/worker-contract-details`
          : `${base}/contract-details`;
        const nav = isCustomerPortal
          ? ["/index", "/contract", "/contract-details"]
          : isStaff
          ? [
              "/index",
              "/staff-member",
              "/worker-contract",
              "/worker-contract-details",
            ]
          : ["/index", "/contract", "/contract-details"];
        navigate(path, { state: { id: item.id, navigats: nav } });
        return;
      }

      if (item.kind === "customer") {
        const path = isStaff
          ? `${base}/staff-member/customer-details`
          : `${base}/customerdetails`;
        const nav = isStaff
          ? ["/index", "/staff-member", "/worker-customer", "/customer-details"]
          : ["/index", "/customer", "/customerdetails"];
        navigate(path, { state: { id: item.id, navigats: nav } });
        return;
      }

      if (item.kind === "worker") {
        navigate(`${base}/worker-details`, {
          state: {
            id: item.id,
            navigats: ["/index", "/manageteam", "/worker-details"],
          },
        });
        return;
      }
    },
    [CompanyUrl, layout, location.pathname, navigate]
  );

  const navSearchInputRef = useRef(null);
  useEffect(() => {
    if (!showGlobalSearchBar) return undefined;
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        navSearchInputRef.current?.focus?.();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [showGlobalSearchBar]);

  const isCjNavDark =
    useCjNavStyle &&
    (theme.palette.mode === "dark" || adminDarkMode || customerDarkMode);
  const cjNavy = isCjNavDark ? "#e8eaed" : "#0F2B46";
  const cjNavyMid = isCjNavDark ? "#b8c5d6" : "#1A3F5C";
  const cjMuted = isCjNavDark
    ? "rgba(232, 234, 237, 0.55)"
    : "rgba(15, 43, 70, 0.55)";
  const cjBorder = isCjNavDark
    ? "rgba(255, 255, 255, 0.12)"
    : "rgba(15, 43, 70, 0.12)";
  const navSearchPlaceholder = isCjNavDark ? "#9aa0a6" : "#6B7280";
  const navSearchBg = isCjNavDark ? "#151d2a" : "#F7F8FA";
  const navSearchBorder = isCjNavDark ? "#2d3b4e" : "#E5E7EB";
  const navSearchFocusBorder = isCjNavDark ? "#60a5fa" : "#0F2B46";
  const navSearchFocusRing = isCjNavDark
    ? "0 0 0 3px rgba(96, 165, 250, 0.28)"
    : "0 0 0 3px rgba(15, 43, 70, 0.18)";
  /** Jobber design-token amber (avatars, activity strip, feed accents) */
  const jobberAmber = "#D4943A";

  return (
    <>
      <Grid
        className={`my-nav ${
          useCjNavStyle
            ? "main-nav-cj-theme"
            : isDonationMode
            ? "bg-white-donor-color"
            : ""
        } ${useCjNavStyle ? "" : "text-white-color"}`}
        style={{
          justifyContent: isMobile ? "space-between" : "",
          padding: isMobile 
            ? (isSmallMobile ? "8px 12px 8px 0" : "8px 16px 8px 0")
            : isTablet 
            ? "8px 20px 8px 0"
            : "8px 24px 8px 0",
          marginBottom: isMobile ? "12px" : "20px",
          alignItems: "center",
          position: "sticky",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 99,
          boxShadow:
            useCjNavStyle
              ? "none"
              : isDonationMode
            ? "var(--shadow-lg)"
            : "none",
          minHeight: isMobile ? "52px" : "56px",
          backgroundColor: useCjNavStyle
            ? isCjNavDark
              ? "#1a2332"
              : "#ffffff"
            : isDonationMode
              ? undefined
              : jobberAmber,
          color: useCjNavStyle ? cjNavy : undefined,
        }}
      >
        <Grid 
          className={`toggle-btn d-md-none d-flex justify-content-between align-items-center mobile-header-row-ref ${
            useCjNavStyle ? "" : "text-white-color"
          }`}
          style={{
            padding: isSmallMobile ? "5px 8px" : "0 12px",
            width: "100%",
            alignItems: "center",
          }}
        >
          <Grid
            style={{
              display: "flex",
              alignItems: "center",
              gap: isSmallMobile ? "10px" : "12px",
              flexShrink: 0,
              flex: useCjNavStyle ? "1 1 0" : undefined,
              minWidth: useCjNavStyle ? 0 : undefined,
            }}
          >
            <MenuRoundedIcon
              className={`${
                useCjNavStyle
                  ? ""
                  : isDonationMode
                  ? "text-donor-color"
                  : "text-white-color"
              }`}
              sx={useCjNavStyle ? { color: cjNavy } : undefined}
              onClick={() => setIsSidebarDisplay(!isSidebarDisplay)}
              style={{
                fontSize: isSmallMobile ? "24px" : "28px",
                cursor: "pointer",
              }}
            />
            {(authNav?.Role === "Worker" || authNav?.Role === "Customer" || authNav?.Role === "Company" || authNav?.Role === "Donor") &&
              (useCjNavStyle ? (
                <Tooltip
                  title={cjNavCompanyDisplayName}
                  arrow
                  placement="bottom-start"
                  enterDelay={400}
                  disableHoverListener={!cjNavCompanyNameTruncated}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "rgba(15, 43, 70, 0.95)",
                        color: "#fff",
                        fontSize: "13px",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        boxShadow: "var(--shadow-md)",
                        maxWidth: "min(420px, 90vw)",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                      },
                    },
                    arrow: {
                      sx: { color: "rgba(15, 43, 70, 0.95)" },
                    },
                  }}
                >
                  <Typography
                    ref={cjNavCompanyMobileRef}
                    component="div"
                    className="d-md-none mobile-cj-company-name"
                    style={{
                      fontWeight: 700,
                      color: cjNavy,
                      fontSize: "18px",
                      letterSpacing: "0.02em",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: 0,
                      flex: "1 1 auto",
                      lineHeight: 1.25,
                    }}
                  >
                    {cjNavCompanyDisplayName}
                  </Typography>
                </Tooltip>
              ) : (
              <Grid
                className="d-md-none"
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "8px",
                    backgroundColor: isDonationMode
                      ? "rgba(104, 178, 203, 0.08)"
                      : "rgba(255, 255, 255, 0.12)",
                  padding: "0",
                  width: "fit-content",
                  maxWidth: "100%",
                    boxShadow: isDonationMode
                      ? "0 2px 8px rgba(104, 178, 203, 0.12)"
                      : "0 2px 8px rgba(255, 255, 255, 0.12)",
                  backdropFilter: "blur(8px)",
                  overflow: "hidden",
                }}
              >
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: isSmallMobile ? "8px 12px" : "8px 14px",
                    width: "fit-content",
                    minHeight: "36px",
                      borderLeft: isDonationMode
                        ? "3px solid #68b2cb"
                        : "3px solid #fff",
                      background: isDonationMode
                        ? "linear-gradient(to right, rgba(104, 178, 203, 0.08) 0%, transparent 100%)"
                        : "linear-gradient(to right, rgba(255, 255, 255, 0.08) 0%, transparent 100%)",
                  }}
                >
                  <Typography
                      className={
                        isDonationMode ? "text-donor-color" : "text-white-color"
                      }
                    style={{
                      fontSize: isSmallMobile ? "11px" : "12px",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                      {authNav?.CompanyName || ""}
                  </Typography>
                </Grid>
              </Grid>
              ))}
          </Grid>
        </Grid>

        <Grid
          className="main-nav-responsive-section"
          style={{
            display: "flex",
            alignItems: isMobile ? "flex-start" : "center",
            width: "100%",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "8px" : (isTablet ? "12px" : (useCjNavStyle ? "10px" : "0")),
            paddingLeft: isMobile ? "0" : "0",
            flexWrap: isTablet && !isMobile ? "wrap" : "nowrap",
          }}
        >
          <Grid
            className="d-flex align-items-center navigator-bar"
            style={{
              marginLeft: isMobile
                ? "12px"
                : useCjNavStyle && isCjPortalRailLayout
                ? `${
                    (!isSidebarClosed
                      ? CJ_PORTAL_SIDEBAR_EXPANDED_PX
                      : CJ_PORTAL_SIDEBAR_COLLAPSED_PX) +
                    (isTablet ? CJ_PORTAL_GUTTER_TABLET_PX : CJ_PORTAL_GUTTER_DESKTOP_PX)
                  }px`
                : isTablet
                ? (!isSidebarClosed ? "240px" : "120px")
                : isSmallDesktop
                ? (!isSidebarClosed ? "260px" : "140px")
                : (!isSidebarClosed ? "285px" : "150px"),
              gap: isMobile ? "12px" : (isTablet ? "16px" : "20px"),
              /* CJ theme: keep left cluster content-sized so global search can use the middle */
              flexShrink: useCjNavStyle && !isMobile ? 1 : 0,
              flex: useCjNavStyle && !isMobile ? "0 1 auto" : undefined,
              minWidth: useCjNavStyle && !isMobile ? 0 : undefined,
              /* Wide enough for 4+ crumb segments on one row; search stays compact on the right */
              maxWidth: useCjNavStyle && !isMobile ? "min(68vw, 780px)" : undefined,
              width: isMobile ? "100%" : "auto",
              flexWrap: isTablet && !isMobile ? "wrap" : "nowrap",
            }}
          >
            {authNav?.Role === "Worker" ||
            authNav?.Role === "Customer" ||
            authNav?.Role === "Company" ||
            authNav?.Role === "Donor" ? (
              !useCjNavStyle || isMobile ? (
              <Grid
                className="logo-box-in-nav"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  borderRadius: isMobile ? "6px" : "8px",
                  backgroundColor: isDonationMode
                    ? "rgba(104, 178, 203, 0.08)"
                    : "rgba(255, 255, 255, 0.12)",
                  padding: "0",
                  transition: "all 0.3s ease",
                  minWidth: isMobile 
                    ? (isSmallMobile ? "160px" : "180px")
                    : isTablet 
                    ? "200px"
                    : "220px",
                  maxWidth: isMobile 
                    ? "100%"
                    : isTablet 
                    ? "400px"
                    : "500px",
                  position: "relative",
                  overflow: "hidden",
                  boxShadow: isDonationMode
                    ? "0 2px 8px rgba(104, 178, 203, 0.12)"
                    : "0 2px 8px rgba(255, 255, 255, 0.12)",
                  backdropFilter: "blur(8px)",
                }}
              >
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: isMobile 
                      ? (isSmallMobile ? "6px 12px" : "6px 14px")
                      : "8px 16px",
                    width: "100%",
                    minHeight: isMobile ? "32px" : "35px",
                    height: "auto",
                    position: "relative",
                    zIndex: 1,
                    borderLeft: isDonationMode
                      ? "3px solid #68b2cb"
                      : "3px solid #fff",
                    background: `linear-gradient(to right, ${
                      isDonationMode
                        ? "rgba(104, 178, 203, 0.08)"
                        : "rgba(255, 255, 255, 0.08)"
                    } 0%, transparent 100%)`,
                  }}
                  onMouseEnter={(e) => {
                    if (!isMobile) {
                      const parent = e.currentTarget.parentElement;
                      if (parent) {
                        parent.style.transform = "translateY(-1px)";
                        parent.style.boxShadow = isDonationMode
                          ? "0 4px 12px rgba(104, 178, 203, 0.2)"
                          : "0 4px 12px rgba(255, 255, 255, 0.2)";
                        parent.style.backgroundColor = isDonationMode
                          ? "rgba(104, 178, 203, 0.15)"
                          : "rgba(255, 255, 255, 0.18)";
                      }
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isMobile) {
                      const parent = e.currentTarget.parentElement;
                      if (parent) {
                        parent.style.transform = "translateY(0)";
                        parent.style.boxShadow = isDonationMode
                          ? "0 2px 8px rgba(104, 178, 203, 0.12)"
                          : "0 2px 8px rgba(255, 255, 255, 0.12)";
                        parent.style.backgroundColor = isDonationMode
                          ? "rgba(104, 178, 203, 0.08)"
                          : "rgba(255, 255, 255, 0.12)";
                      }
                    }
                  }}
                >
                  <Grid
                    style={{
                      width: isMobile ? "22px" : "25px",
                      height: isMobile ? "22px" : "25px",
                      borderRadius: isMobile ? "5px" : "6px",
                      backgroundColor: isDonationMode ? "#68b2cb" : "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: isMobile ? "10px" : "12px",
                      fontSize: isMobile ? "14px" : "16px",
                      fontWeight: "700",
                      color: isDonationMode ? "#fff" : "#f4811f",
                      boxShadow: isDonationMode
                        ? "0 2px 6px rgba(104, 178, 203, 0.3)"
                        : "0 2px 6px rgba(244, 129, 31, 0.3)",
                      transition: "all 0.3s ease",
                      border: isDonationMode
                        ? "1px solid rgba(104, 178, 203, 0.3)"
                        : "1px solid rgba(255, 255, 255, 0.3)",
                    }}
                  >
                    {(authNav?.CompanyName || "UC")
                      ?.charAt(0)
                      ?.toUpperCase()}
                  </Grid>
                  <Grid style={{ flex: 1, minWidth: 0 }}>
                    <Tooltip
                      title={authNav?.CompanyName || "Unnamed Company"}
                      arrow
                      placement="bottom-start"
                      enterDelay={500}
                      componentsProps={{
                        tooltip: {
                          sx: {
                            backgroundColor: isDonationMode 
                              ? "rgba(104, 178, 203, 0.95)" 
                              : "rgba(6, 49, 100, 0.95)",
                            color: "white",
                            fontSize: "13px",
                            padding: "8px 12px",
                            borderRadius: "6px",
                            boxShadow: isDonationMode
                              ? "0 4px 12px rgba(104, 178, 203, 0.3)"
                              : "0 4px 12px rgba(6, 49, 100, 0.3)",
                            maxWidth: "500px",
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                          }
                        },
                        arrow: {
                          sx: {
                            color: isDonationMode 
                              ? "rgba(104, 178, 203, 0.95)" 
                              : "rgba(6, 49, 100, 0.95)"
                          }
                        }
                      }}
                    >
                      <Typography
                        className={`${
                          isDonationMode ? "text-donor-color" : "text-white-color"
                        }`}
                        style={{
                          fontSize: isMobile 
                            ? (isSmallMobile ? "11px" : "12px")
                            : isTablet 
                            ? "12px"
                            : "13px",
                          fontWeight: 600,
                          margin: 0,
                          textTransform: "uppercase",
                          letterSpacing: isMobile ? "0.3px" : "0.5px",
                          fontFamily: '"Inter", "Segoe UI", sans-serif',
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          lineHeight: "1.5",
                          wordBreak: "break-word",
                          wordWrap: "break-word",
                          cursor: "pointer",
                        }}
                      >
                        {authNav?.CompanyName || "Unnamed Company"}
                      </Typography>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Tooltip
                title={cjNavCompanyDisplayName}
                arrow
                placement="bottom-start"
                enterDelay={400}
                disableHoverListener={!cjNavCompanyNameTruncated}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "rgba(15, 43, 70, 0.95)",
                      color: "#fff",
                      fontSize: "13px",
                      padding: "8px 12px",
                      borderRadius: "6px",
                      boxShadow: "var(--shadow-md)",
                      maxWidth: "min(420px, 90vw)",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                    },
                  },
                  arrow: {
                    sx: { color: "rgba(15, 43, 70, 0.95)" },
                  },
                }}
              >
                <Typography
                  ref={cjNavCompanyDesktopRef}
                  component="div"
                  className="cj-nav-company-name"
                  style={{
                    fontWeight: 700,
                    color: cjNavy,
                    fontSize: "18px",
                    letterSpacing: "0.02em",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: isTablet ? "120px" : "168px",
                    minWidth: 0,
                    flex: "0 0 auto",
                  }}
                >
                  {cjNavCompanyDisplayName}
                </Typography>
              </Tooltip>
            )
            ) : null}
            <Breadcrumb
              className={`text-light breadcrumb ${
                useCjNavStyle
                  ? "breadcrumb-cj-nav"
                  : isDonationMode
                  ? "text-donor-color"
                  : "text-white-color"
              }`}
              listTag="Grid"
              tag="Grid"
              style={{
                border: useCjNavStyle
                  ? `1px solid ${cjBorder}`
                  : isDonationMode
                  ? "1px solid #68b2cb"
                  : "1px solid rgba(255, 255, 255, 0.3)",
                display: "flex",
                alignItems: "center",
                padding: isMobile 
                  ? (isSmallMobile ? "4px 8px" : "5px 10px")
                  : isTablet 
                  ? "5px 11px"
                  : "6px 12px",
                borderRadius: useCjNavStyle ? "999px" : isMobile ? "3px" : "4px",
                cursor: "pointer",
                background: useCjNavStyle
                  ? isCjNavDark
                    ? "rgba(255, 255, 255, 0.06)"
                    : "rgba(15, 43, 70, 0.04)"
                  : "rgba(255, 255, 255, 0.1)",
                maxWidth: isMobile ? "100%" : "fit-content",
                overflow: isMobile ? "hidden" : "visible",
                flexWrap: isMobile ? "wrap" : "nowrap",
                ...(useCjNavStyle && !isMobile
                  ? {
                      flex: "1 1 0",
                      flexWrap: "nowrap",
                      whiteSpace: "nowrap",
                      overflowX: "auto",
                      overflowY: "hidden",
                      maxWidth: "100%",
                      minWidth: 0,
                      scrollbarWidth: "thin",
                    }
                  : {}),
              }}
            >
              {(() => {
                const rawItems =
                  navigateItems?.length > 0
                    ? navigateItems
                    : location?.pathname?.endsWith("/index") &&
                        !location?.pathname?.includes("superadmin")
                      ? [{ name: "Home", path: "/index" }]
                      : [];
                const seen = new Set();
                const itemsToShow = [];
                for (const it of rawItems) {
                  if (!it?.name) continue;
                  const key = it.path ?? it.name;
                  if (seen.has(key)) continue;
                  seen.add(key);
                  itemsToShow.push(it);
                }

                return itemsToShow.length > 0 && itemsToShow.map((name, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && (
                      <ArrowRightIcon
                        style={{
                          fontSize: isMobile 
                            ? (isSmallMobile ? "14px" : "16px")
                            : isTablet 
                            ? "17px"
                            : "18px",
                          opacity: useCjNavStyle ? 1 : "0.7",
                          color: useCjNavStyle ? cjMuted : undefined,
                          margin: isMobile ? "0 1px" : "0 2px",
                        }}
                      />
                    )}
                    <BreadcrumbItem
                      onClick={() => {
                        if (index === 0) {
                          if (authNav?.Role === "Donor") {
                            navigate(`/${CompanyUrl}/donors/index`, {
                              state: {
                                navigats: ["/index", "/donors", "/index"],
                                breadcrumbs: ["Home"],
                              },
                            });
                          } else if (authNav?.Role === "Customer") {
                            navigate(`/${CompanyUrl}/customers/index`, {
                              state: {
                                navigats: ["/index", "/customers", "/index"],
                                breadcrumbs: ["Home"],
                              },
                            });
                          } else if (authNav?.Role === "Worker") {
                            navigate(`/${CompanyUrl}/staff-member/index`, {
                              state: {
                                navigats: ["/index", "/staff-member", "/index"],
                                breadcrumbs: ["Home"],
                              },
                            });
                          } else if (
                            location.pathname?.split("/")[1] === "superadmin"
                          ) {
                            navigate(`/superadmin/index`, {
                              state: {
                                navigats: ["/index"],
                                breadcrumbs: ["Home"],
                              },
                            });
                          } else {
                            navigate(`/${CompanyUrl}/index`, {
                              state: {
                                navigats: ["/index"],
                                breadcrumbs: ["Home"],
                              },
                            });
                          }
                        } else if (index !== itemsToShow.length - 1) {
                          navigate(-1);
                        }
                      }}
                      style={{
                        fontSize: isMobile 
                          ? (isSmallMobile ? "11px" : "12px")
                          : isTablet 
                          ? "12px"
                          : "13px",
                        fontWeight:
                          index === itemsToShow.length - 1 ? "600" : "400",
                        opacity: useCjNavStyle
                          ? 1
                          : index === itemsToShow.length - 1
                          ? "1"
                          : "0.8",
                        color: useCjNavStyle
                          ? index === itemsToShow.length - 1
                            ? cjNavy
                            : isCjNavDark
                              ? "#9aa0a6"
                              : "#6B7280"
                          : undefined,
                        padding: isMobile ? "0 2px" : "0 4px",
                        whiteSpace: isMobile ? "normal" : "nowrap",
                        maxWidth: isMobile ? "120px" : "none",
                        overflow: isMobile ? "hidden" : "visible",
                        textOverflow: isMobile ? "ellipsis" : "clip",
                      }}
                    >
                      {location?.state?.breadcrumbs?.[index]?.replace(
                        "Home",
                        "Dashboard"
                      ) ||
                        name?.name?.replace("Home", "Dashboard") ||
                        "Dashboard"}
                    </BreadcrumbItem>
                  </React.Fragment>
                ));
              })()}
            </Breadcrumb>
          </Grid>

          {!isMobile &&
            (showGlobalSearchBar ? (
              <Grid
                style={{
                  /* CJ: compact pill (~300px) like before; do not stretch full middle */
                  flex: useCjNavStyle ? "0 0 auto" : "0 1 480px",
                  maxWidth: useCjNavStyle ? 300 : 480,
                  minWidth: 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "0 8px",
                  marginLeft: useCjNavStyle ? "auto" : undefined,
                  flexShrink: 0,
                }}
              >
                <ClickAwayListener
                  onClickAway={() => setGlobalSearchOpen(false)}
                >
                  <Box
                    ref={setGlobalSearchAnchorEl}
                    sx={{ position: "relative", width: "100%" }}
                  >
                    <Paper
                      className="main-nav-search-pill"
                      component="div"
                      elevation={0}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        maxHeight: 34,
                        minHeight: 30,
                        borderRadius: "999px",
                        border: `1px solid ${navSearchBorder}`,
                        backgroundColor: navSearchBg,
                        px: 1.25,
                        py: 0.25,
                        boxSizing: "border-box",
                        transition:
                          "background-color 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease",
                        "&:focus-within": {
                          backgroundColor: isCjNavDark ? "#1e2a3d" : "#FFFFFF",
                          borderColor: navSearchFocusBorder,
                          boxShadow: navSearchFocusRing,
                        },
                      }}
                    >
                      <SearchInput
                        inputRef={navSearchInputRef}
                        value={globalSearchQuery}
                        onChange={(e) => setGlobalSearchQuery(e.target.value)}
                        onFocus={() => {
                          if (
                            globalSearchResults.length > 0 ||
                            globalSearchLoading
                          ) {
                            setGlobalSearchOpen(true);
                          }
                        }}
                        placeholder="Search... (⌘K)"
                        fieldHeight="30px"
                        fullWidth
                        ariaLabel="Global search"
                        className="main-nav-search-field"
                        startAdornment={
                          <SearchIcon
                            sx={{
                              color: isCjNavDark ? "#9aa0a6" : "#9CA3AF",
                              mr: 0.75,
                              fontSize: 18,
                              flexShrink: 0,
                            }}
                          />
                        }
                        inputProps={{
                          style: {
                            color: cjNavy,
                            WebkitTextFillColor: cjNavy,
                            fontSize: "0.8125rem",
                            lineHeight: 1.25,
                            padding: "4px 0",
                          },
                        }}
                      />
                    </Paper>
                    <Popper
                      open={
                        globalSearchOpen &&
                        globalSearchQuery.trim().length >= 2
                      }
                      anchorEl={globalSearchAnchorEl}
                      placement="bottom-start"
                      transition
                      disablePortal
                      modifiers={[
                        {
                          name: "offset",
                          options: { offset: [0, 6] },
                        },
                        {
                          name: "sameWidth",
                          enabled: true,
                          phase: "beforeWrite",
                          requires: ["computeStyles"],
                          fn: ({ state }) => {
                            state.styles.popper.width = `${state.rects.reference.width}px`;
                          },
                        },
                      ]}
                      sx={{ zIndex: 1300 }}
                    >
                      {({ TransitionProps }) => (
                        <Grow {...TransitionProps} timeout={180}>
                          <Paper
                            elevation={8}
                            sx={{
                              maxHeight: 320,
                              overflow: "auto",
                              border: `1px solid ${navSearchBorder}`,
                            }}
                          >
                            {globalSearchLoading && (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  py: 2,
                                }}
                              >
                                <CircularProgress size={22} />
                              </Box>
                            )}
                            {!globalSearchLoading &&
                              globalSearchResults.length === 0 && (
                                <Typography
                                  sx={{
                                    p: 1.5,
                                    fontSize: "0.8125rem",
                                    color: navSearchPlaceholder,
                                  }}
                                >
                                  No matches
                                </Typography>
                              )}
                            <List dense disablePadding>
                              {globalSearchResults.map((row) => (
                                <ListItemButton
                                  key={`${row.kind}-${row.id}`}
                                  onClick={() => openGlobalSearchResult(row)}
                                  sx={{
                                    alignItems: "flex-start",
                                    py: 1,
                                  }}
                                >
                                  <ListItemText
                                    primary={row.label}
                                    secondary={row.description || row.kind}
                                    primaryTypographyProps={{
                                      fontSize: "0.8125rem",
                                      fontWeight: 600,
                                      color: cjNavy,
                                    }}
                                    secondaryTypographyProps={{
                                      fontSize: "0.75rem",
                                      color: navSearchPlaceholder,
                                    }}
                                  />
                                </ListItemButton>
                              ))}
                            </List>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </Box>
                </ClickAwayListener>
              </Grid>
            ) : useCjNavStyle ? (
              <Grid
                className="cj-nav-search-placeholder"
                style={{
                  flex: "0 0 auto",
                  maxWidth: 300,
                  minWidth: 0,
                  marginLeft: "auto",
                }}
              />
            ) : (
              <Grid style={{ flex: 1, minWidth: 0 }} />
            ))}

          {!useCjNavStyle && (
          <Grid
            style={{
              display: "flex",
              alignItems: "center",
              flexShrink: 1,
              flex: "1 1 0",
              minWidth: 0,
              justifyContent: "flex-end",
              marginLeft: 0,
              gap: isTablet ? 8 : 12,
            }}
          >
            {showSalesSupport && (
            <Grid
              className="need-help-section d-md-flex d-none"
              style={{
                display: "flex",
                alignItems: "center",
                padding: isTablet ? "6px 12px" : "8px 16px",
                gap: isTablet ? "12px" : "16px",
                flexShrink: 0,
                maxWidth: isTablet ? "200px" : "none",
              }}
            >
              <Grid
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                  flexShrink: 0,
                }}
              >
                <Typography
                  style={{
                    fontSize: isTablet ? "10px" : "11px",
                      color: useCjNavStyle
                        ? cjMuted
                        : isDonationMode
                        ? "#68b2cb"
                        : "rgba(255, 255, 255, 0.9)",
                    lineHeight: "1.3",
                    whiteSpace: "nowrap",
                  }}
                >
                  Sales:{" "}
                  <a
                    href={`tel:${formatPhoneForTelLink(supportSettings?.SalesPhone || DEFAULT_SALES_PHONE)}`}
                    style={{
                      fontWeight: 600,
                        color: useCjNavStyle
                          ? cjNavy
                          : isDonationMode
                          ? "#68b2cb"
                          : "#FFF",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.textDecoration = "underline";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.textDecoration = "none";
                    }}
                  >
                    {formatPhoneForDisplay(supportSettings?.SalesPhone || DEFAULT_SALES_PHONE)}
                  </a>
                </Typography>
                <Typography
                  style={{
                    fontSize: isTablet ? "10px" : "11px",
                      color: useCjNavStyle
                        ? cjMuted
                        : isDonationMode
                        ? "#68b2cb"
                        : "rgba(255, 255, 255, 0.9)",
                    lineHeight: "1.3",
                    whiteSpace: "nowrap",
                  }}
                >
                  Support:{" "}
                  <a
                    href={`tel:${formatPhoneForTelLink(supportSettings?.SupportPhone || DEFAULT_SUPPORT_PHONE)}`}
                    style={{
                      fontWeight: 600,
                        color: useCjNavStyle
                          ? cjNavyMid
                          : isDonationMode
                          ? "#68b2cb"
                          : "#FFF",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.textDecoration = "underline";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.textDecoration = "none";
                    }}
                  >
                    {formatPhoneForDisplay(supportSettings?.SupportPhone || DEFAULT_SUPPORT_PHONE)}
                  </a>
                </Typography>
              </Grid>
            </Grid>
          )}
            <Grid />
          </Grid>
          )}

          <Grid
            className="setting-notification Notificatin-setting d-flex settingNotificationIcon"
            style={{ 
                marginLeft:
                  useCjNavStyle && !isMobile
                    ? 0
                    : showSalesSupport && !useCjNavStyle
                    ? isTablet
                      ? "8px"
                      : "12px"
                : "0",
              flexShrink: 0,
            }}
          >
              <Grid
                style={{
                  display: "flex",
                  background: useCjNavStyle
                    ? "rgba(15, 43, 70, 0.06)"
                    : isDonationMode
                    ? "rgba(104, 178, 203, 0.2)"
                    : "rgba(255, 255, 255, 0.2)",
                  borderRadius: isTablet ? "8px" : "10px",
                  padding: isTablet ? "4px" : "0",
                }}
              >
                {showAiInNav && (
                  <>
                <Grid
                  className={isTablet ? "mx-2" : "mx-3"}
                  onClick={handleAiChatClick}
                  style={{
                    cursor: "pointer",
                    color: "#FFF",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Tooltip
                    title="Chat with AI Assistant"
                    placement="bottom"
                    arrow
                  >
                    <img
                      src={isDonationMode ? DonorChatBotIcon : ChatBotIcon}
                      alt="ChatBotIcon"
                      style={{
                        width: isTablet ? "20px" : "22px",
                        height: isTablet ? "20px" : "22px",
                      }}
                    />
                  </Tooltip>
                </Grid>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{
                    height: isTablet ? "18px" : "20px",
                        border: useCjNavStyle
                          ? `1px solid ${cjBorder}`
                          : "2px solid #FFFF",
                    alignItems: "center",
                    margin: isTablet ? "4px" : "5px",
                    marginTop: isTablet ? "8px" : "10px",
                  }}
                />
                  </>
                )}

                <Nav
                  className="align-items-center d-flex mx-3 justify-content-end"
                  navbar
                > 
                  <UncontrolledDropdown nav>
                    <Grid className="">
                      <DropdownToggle className="pr-0" nav>
                        {isDonationMode ? (
                          <img src={DonorSetting} alt="Donor" />
                        ) : useCjNavStyle ? (
                          <SettingsOutlinedIcon
                            sx={{
                              fontSize: isTablet ? 22 : 24,
                              color: cjNavy,
                            }}
                          />
                        ) : (
                          <img src={setting} alt="Setting" />
                        )}
                      </DropdownToggle>
                      <DropdownMenu
                        end
                        className={`dropdown-menu-arrow ${
                          isDonationMode
                            ? "bg-donor-color"
                            : useCjNavStyle
                              ? "cj-nav-settings-menu--sidebar-amber"
                              : ""
                        }`}
                      >
                        <DropdownItem
                          className=" d-flex gap-2 align-items-center"
                          tag="Grid"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            if (
                              location?.pathname?.split("/")[2] ===
                                "customers" ||
                              location?.pathname?.split("/")[2] ===
                                "staff-member" ||
                              location?.pathname?.split("/")[2] === "donors"
                            ) {
                              if (
                                location?.pathname?.split("/")[2] ===
                                "customers"
                              ) {
                                navigate(`/${CompanyUrl}/customers/profile`, {
                                  state: {
                                    navigats: [
                                      "/index",
                                      `/${CompanyUrl}/customers/profile`,
                                    ],
                                  },
                                });
                              } else if (
                                location?.pathname?.split("/")[2] ===
                                "staff-member"
                              ) {
                                navigate(
                                  `/${CompanyUrl}/staff-member/profile`,
                                  {
                                    state: {
                                      navigats: [
                                        "/index",
                                        `/${CompanyUrl}/staff-member/profile`,
                                      ],
                                    },
                                  }
                                );
                              } else if (
                                location?.pathname?.split("/")[2] === "donors"
                              ) {
                                navigate(`/${CompanyUrl}/donors/profile`, {
                                  state: {
                                    navigats: ["/index", "/profile"],
                                  },
                                });
                              }
                            } else if (CompanyUrl) {
                              navigate(`/${CompanyUrl}/profile`, {
                                state: {
                                  navigats: ["/index", "/profile"],
                                },
                              });
                            } else if (
                              location?.pathname?.split("/")[1] === "superadmin"
                            ) {
                              navigate(`/superadmin/SuperAdminProfile`, {
                                state: {
                                  navigats: ["/index", "SuperAdminProfile"],
                                },
                              });
                            } else {
                              navigate(`/${CompanyUrl}/staff-member/profile`, {
                                state: {
                                  navigats: [
                                    "/index",
                                    `/${CompanyUrl}/staff-member/profile`,
                                  ],
                                },
                              });
                            }
                          }}
                        >
                          <>
                            {data?.ProfileImage?.trim() && !profileImageLoadError ? (
                              <img
                                src={`${cdnUrl}/v1/cdn/upload/${data?.ProfileImage}`}
                                alt="Profile"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "5px",
                                  objectFit: "cover",
                                }}
                                onError={handleProfileImageError}
                              />
                            ) : (
                              <Typography
                                className={` bg-white-color ${
                                  isDonationMode
                                    ? "text-donor-color"
                                    : useCjNavStyle
                                      ? "cj-nav-settings-menu-initials"
                                      : ""
                                }`}
                                sx={
                                  !isDonationMode && !useCjNavStyle
                                    ? { color: jobberAmber }
                                    : undefined
                                }
                                style={{
                                  fontWeight: 700,
                                  padding: "8px",
                                  borderRadius: "4px",
                                  minWidth: "40px",
                                  minHeight: "40px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {getInitials(
                                  data?.FirstName,
                                  data?.LastName,
                                  data?.FullName,
                                  data?.OwnerName
                                )}
                              </Typography>
                            )}
                          </>
                          <Grid className="text-light">
                            <Typography
                              className="mb-0"
                              style={{ fontSize: "12px" }}
                            >
                              <Typography
                                className="bold-text"
                                style={{ fontSize: "12px" }}
                              >
                                {formatName(
                                  data?.FirstName,
                                  data?.LastName,
                                  data?.FullName
                                ) || data?.OwnerName || ""}
                              </Typography>
                            </Typography>
                            <Typography
                              className="mb-0 e-mail"
                              style={{ fontSize: "10px" }}
                            >
                              {data?.EmailAddress || data?.EmailAddress}
                            </Typography>
                          </Grid>
                        </DropdownItem>
                        <Divider sx={{ backgroundColor: "white" }} />
                        {!location?.pathname?.includes("/superadmin") &&
                          !location?.pathname?.includes("/customers") &&
                          !location?.pathname?.includes("/staff-member") &&
                          !location?.pathname?.includes("/donors") && (
                            <>
                              <DropdownItem
                                className="mb-2 text-light"
                                onClick={() => {
                                  if (
                                    !location?.pathname?.includes("/customers")
                                  ) {
                                    navigate(
                                      CompanyUrl
                                        ? `/${CompanyUrl}/account`
                                        : `/superadmin/account`,
                                      {
                                        state: {
                                          navigats: [
                                            "/index",
                                            "/account",
                                          ],
                                        },
                                      }
                                    );
                                  }
                                }}
                              >
                                <img src={settingiconsidebar} alt="Settings" />
                                <span
                                  className="mx-2"
                                  style={{ fontSize: "12px" }}
                                >
                                  Settings
                                </span>
                              </DropdownItem>

                              <Divider sx={{ backgroundColor: "white" }} />
                              <DropdownItem
                                className="mb-2 text-light"
                                onClick={() => {
                                  if (
                                    !location?.pathname?.includes("/customers")
                                  ) {
                                    navigate(
                                      CompanyUrl
                                        ? `/${CompanyUrl}/account-billing`
                                        : "/superadmin/account-billing",
                                      {
                                        state: {
                                          navigats: [
                                            "/index",
                                            "/account-billing",
                                          ],
                                        },
                                      }
                                    );
                                  }
                                }}
                              >
                                <img src={AccountBilling} alt="Account & Billing" />
                                <span
                                  className="mx-2"
                                  style={{ fontSize: "12px" }}
                                >
                                  Account & Billing
                                </span>
                              </DropdownItem>
                              <Divider sx={{ backgroundColor: "white" }} />
                              <DropdownItem
                                className="mb-2 text-light"
                                onClick={() => {
                                  if (
                                    !location?.pathname?.includes("/customers")
                                  ) {
                                    navigate(
                                      CompanyUrl
                                        ? `/${CompanyUrl}/activity `
                                        : "/superadmin/activity",
                                      {
                                        state: {
                                          navigats: ["/index", "/activity"],
                                        },
                                      }
                                    );
                                  }
                                }}
                              >
                                <img src={Activity} alt="Activity" />
                                <span
                                  className="mx-2"
                                  style={{ fontSize: "12px" }}
                                >
                                  Activity
                                </span>
                              </DropdownItem>
                              <Divider sx={{ backgroundColor: "white" }} />
                              {!isDonationMode && (
                                <DropdownItem
                                  className="mb-2 text-light"
                                  onClick={() => {
                                    if (
                                      !location?.pathname?.includes(
                                        "/customers"
                                      )
                                    ) {
                                      navigate(
                                        CompanyUrl
                                          ? `/${CompanyUrl}/manageteam `
                                          : "/superadmin/manageteam",
                                        {
                                          state: {
                                            navigats: ["/index", "/manageteam"],
                                          },
                                        }
                                      );
                                    }
                                  }}
                                >
                                  <img src={ManageTeam} alt="Manage Team" />
                                  <span
                                    className="mx-2"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Manage Team
                                  </span>
                                </DropdownItem>
                              )}
                              <Divider sx={{ backgroundColor: "white" }} />
                              <DropdownItem
                                className="mb-2 text-light"
                                onClick={() => {
                                  if (
                                    !location?.pathname?.includes("/customers")
                                  ) {
                                    navigate(
                                      CompanyUrl
                                        ? `/${CompanyUrl}/contact-support`
                                        : "/superadmin/contact-support",
                                      {
                                        state: {
                                          navigats: ["/index", "/contact-support"],
                                        },
                                      }
                                    );
                                  }
                                }}
                              >
                                <HelpOutlineIcon />
                                <span
                                  className="mx-2"
                                  style={{ fontSize: "12px" }}
                                >
                                  Contact Support
                                </span>
                              </DropdownItem>
                              <Divider sx={{ backgroundColor: "white" }} />
                            </>
                          )}
                        {portalThemePath && (
                          <>
                            <DropdownItem
                              className="mb-2 text-light d-flex align-items-center gap-2"
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(portalThemePath, {
                                  state: {
                                    navigats: ["/index", "/settings/theme"],
                                  },
                                });
                              }}
                            >
                              <PaletteOutlinedIcon
                                sx={{ fontSize: 20 }}
                                aria-hidden
                              />
                              <span style={{ fontSize: "12px" }}>Mode</span>
                            </DropdownItem>
                            <Divider
                              sx={{
                                backgroundColor: isCjNavDark
                                  ? "rgba(255,255,255,0.15)"
                                  : "white",
                              }}
                            />
                          </>
                        )}
                        <DropdownItem
                          onClick={useRemoveToken}
                          className="mb-2 text-light"
                        >
                          <img src={Logout} alt="Log Out" />
                          <span className="mx-2" style={{ fontSize: "12px" }}>
                            Log Out
                          </span>
                        </DropdownItem>
                      </DropdownMenu>
                    </Grid>
                  </UncontrolledDropdown>
                </Nav>

                <Divider
                  orientation="vertical"
                  flexItem
                  style={{
                    height: isTablet ? "18px" : "20px",
                    border: useCjNavStyle
                      ? `1px solid ${cjBorder}`
                      : "2px solid #FFFF",
                    alignItems: "center",
                    margin: isTablet ? "4px" : "5px",
                    marginTop: isTablet ? "8px" : "10px",
                  }}
                />
                {/* Notification Icon */}
                <Grid
                  className={isTablet ? "mx-2" : "mx-3"}
                  onClick={handleNotificationsClick}
                  style={{
                    cursor: "pointer",
                    color: useCjNavStyle ? cjNavy : "#FFF",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    flexShrink: 0,
                    overflow: "visible",
                  }}
                >
                  {isDonationMode ? (
                    <img 
                      src={DonorNotification} 
                      alt="Donor"
                      style={{
                        width: isTablet ? "20px" : "24px",
                        height: isTablet ? "20px" : "24px",
                      }}
                    />
                  ) : (
                    <NotificationsNoneIcon 
                      style={{ fontSize: isTablet ? "20px" : "24px" }}
                    />
                  )}
                  {recountNotification && setRecountNotification(false)}
                  {!recountNotification && localNotificationCount > 0 && (
                    useCjNavStyle ? (
                      <span
                        style={{
                          position: "absolute",
                          top: 2,
                          right: 4,
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          background: "#e53935",
                          border: isCjNavDark
                            ? "2px solid #1a2332"
                            : "2px solid #fff",
                        }}
                      />
                    ) : (
                    <Typography
                      style={{
                        position: "absolute",
                        top: -5,
                        right: -5,
                        background: "red",
                        borderRadius: "50%",
                        color: "white",
                        padding: isTablet ? "1px 5px" : "2px 6px",
                        fontSize: isTablet ? "10px" : "12px",
                        fontWeight: "bold",
                        minWidth: isTablet ? "16px" : "18px",
                        textAlign: "center",
                        lineHeight: isTablet ? "14px" : "16px",
                      }}
                    >
                      {localNotificationCount > 99 ? "99+" : localNotificationCount}
                    </Typography>
                    )
                  )}
                </Grid>
              </Grid>
              <Grid>
              </Grid>
            </Grid>
          
          </Grid>
        </Grid>
        {isNotify && (
          <>
            {/* Backdrop overlay for mobile */}
            <Grid
              className="notification-backdrop"
              onClick={handleCloseNotifications}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 999,
                display: "flex",
              }}
            />
            <Grid
              className="notification-bar"
              style={{
                position: "fixed",
                top: 0,
                right: 0,
                width: isMobile
                  ? (isSmallMobile ? "100vw" : "90vw")
                  : isTablet
                  ? "380px"
                  : "400px",
                maxWidth: "100vw",
                height: "100vh",
                backgroundColor:
                  adminDarkMode || customerDarkMode || theme.palette.mode === "dark"
                    ? "#1a2332"
                    : "#ffffff",
                borderRadius: isMobile ? "0" : "16px 0 0 16px",
                boxShadow: "var(--shadow-xl)",
                border:
                  adminDarkMode || customerDarkMode || theme.palette.mode === "dark"
                    ? "1px solid #2d3b4e"
                    : "1px solid #e8f0fe",
                overflow: "hidden",
                zIndex: 1000,
                display: "flex",
                flexDirection: "column",
                animation: "slideInNotification 0.3s ease-out",
              }}
            >
            <Grid
              className={`notification-header w-100 d-flex justify-content-between align-items-center ${
                isDonationMode ? "bg-donor-color" : "bg-blue-color"
              }`}
              style={{
                padding: isMobile 
                  ? (isSmallMobile ? "16px 16px" : "18px 20px")
                  : isTablet 
                  ? "18px 22px"
                  : "20px 24px",
                borderBottom: "1px solid #e8f0fe",
                flexShrink: 0,
              }}
            >
              <Typography
                className="text-white"
                style={{
                  fontSize: isMobile 
                    ? (isSmallMobile ? "16px" : "17px")
                    : isTablet 
                    ? "17px"
                    : "18px",
                  fontWeight: "700",
                  margin: "0",
                  display: "flex",
                  alignItems: "center",
                  gap: isMobile ? "6px" : "8px",
                }}
              >
                <NotificationsNoneIcon 
                  style={{ 
                    fontSize: isMobile 
                      ? (isSmallMobile ? "18px" : "19px")
                      : isTablet 
                      ? "19px"
                      : "20px" 
                  }} 
                />
                Activity Feed
              </Typography>
              <Button
                variant="contained"
                onClick={handleCloseNotifications}
                sx={{
                  minWidth: "auto",
                  padding: isMobile 
                    ? (isSmallMobile ? "6px 10px" : "7px 11px")
                    : "8px 12px",
                  borderRadius: "50%",
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  border: "none",
                  transition: "all 0.2s ease",
                  cursor: "pointer",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                    transform: "scale(1.1)",
                  },
                }}
              >
                <CloseRoundedIcon 
                  style={{ 
                    fontSize: isMobile 
                      ? (isSmallMobile ? "16px" : "17px")
                      : isTablet 
                      ? "17px"
                      : "18px" 
                  }} 
                />
              </Button>
            </Grid>

            {!openCustome ? (
              <>
                <Grid
                  className="notification-p d-flex justify-content-between align-items-center"
                  style={{
                    padding: "16px 24px",
                    borderBottom: "1px solid #f0f2f5",
                    backgroundColor: "#fafbfc",
                    flexShrink: 0,
                  }}
                >
                  <Typography
                    className="customise"
                    style={{
                      cursor: "pointer",
                      color: isDonationMode ? "#68b2cb" : "#0f2b46",
                      fontWeight: "600",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "all 0.2s ease",
                      userSelect: "none",
                      border: "none",
                      "&:hover": {
                        textDecoration: "none !important",
                      },
                    }}
                    component="div"
                    onClick={() => setOpenCustome(!openCustome)}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke={isDonationMode ? "#68b2cb" : "#0f2b46"}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="3" />
                      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
                    </svg>
                    Customize Feed
                  </Typography>
                  {(localNotificationCount > 0 || notifications.length > 0) && (
                    <Notifications
                      fetchNotifications={fetchNotifications}
                      viewAll={viewAll}
                      isDonationMode={isDonationMode}
                      handleCloseNotifications={handleCloseNotifications}
                    />
                  )}
                </Grid>

                <Grid
                  style={{
                    flex: 1,
                    overflowY: "auto",
                    scrollbarWidth: "thin",
                    marginTop: "20px",
                    paddingTop: "10px",
                  }}
                >
                  {NotificationPage === 0 && (
                    <Grid
                      style={{
                        padding: "40px 24px",
                        textAlign: "center",
                      }}
                    >
                      <Grid
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 16px",
                          boxShadow: "var(--shadow-lg)",
                        }}
                      >
                        <NotificationsNoneIcon
                          style={{
                            color: "white",
                            fontSize: "32px",
                          }}
                        />
                      </Grid>
                      <Typography
                        style={{
                          fontSize: "16px",
                          color: "#6b7280",
                          fontWeight: "500",
                          margin: "0",
                        }}
                      >
                        No activities to report
                      </Typography>
                      <Typography
                        style={{
                          fontSize: "14px",
                          color: "#9ca3af",
                          marginTop: "4px",
                        }}
                      >
                        New activities will appear here
                      </Typography>
                    </Grid>
                  )}

                  <NotificationPage
                    handleCloseNotifications={handleCloseNotifications}
                    isSwitchOn={isSwitchOn}
                    fetchNotifications={fetchNotifications}
                    notifications={notifications}
                    isDonationMode={isDonationMode}
                    loader={loader}
                    totalCount={notificationPagination.totalCount}
                    totalAllNotifications={notificationPagination.totalAllNotifications}
                    totalPages={notificationPagination.totalPages}
                    currentPage={notificationPagination.currentPage}
                  />
                </Grid>
              </>
            ) : (
              <Grid
                className="notification-feed-customize"
                style={{ flex: 1, overflowY: "auto" }}
              >
                <Grid
                  className="notication-back"
                  onClick={() => {
                    setOpenCustome(!openCustome);
                    fetchNotifications(true);
                  }}
                  style={{
                    padding: "16px 24px",
                    cursor: "pointer",
                    color: isDonationMode ? "#68b2cb" : "#0f2b46",
                    fontWeight: "600",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    borderBottom: "1px solid #f0f2f5",
                    backgroundColor: "#fafbfc",
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <ArrowBackIosIcon style={{ fontSize: "16px" }} />
                  Back to Notifications
                </Grid>

                <Grid style={{ padding: "16px 0" }}>
                  {[
                    {
                      key: "customers",
                      label: "Customer Creation",
                      icon: (
                        <PersonOutlineIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: false,
                      showForCompany: true,
                      showForCustomer: false,
                    },
                    {
                      key: "donors",
                      label: "Donors",
                      icon: (
                        <PersonOutlineIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: true,
                      showForCompany: false,
                      showForCustomer: false,
                    },
                    {
                      key: "donations",
                      label: "Donations",
                      icon: (
                        <AccountBalanceWalletOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: true,
                      showForCompany: false,
                      showForCustomer: false,
                    },
                    {
                      key: "DonorCreateNotification",
                      label: "Donor Creation",
                      icon: (
                        <PersonOutlineIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: true,
                      showForCompany: false,
                      showForCustomer: false,
                    },
                    {
                      key: "DonorPaymentNotification",
                      label: "Donor Payments",
                      icon: (
                        <PaymentsOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: true,
                      showForCompany: false,
                      showForCustomer: false,
                    },
                    {
                      key: "quotes",
                      label: "Quote Creation",
                      icon: (
                        <DescriptionOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: false,
                      showForCompany: true,
                      showForCustomer: false,
                    },
                    {
                      key: "contracts",
                      label: "Contract Creation",
                      icon: (
                        <ArticleOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: false,
                      showForCompany: true,
                      showForCustomer: false,
                    },
                    {
                      key: "invoices",
                      label: "Invoice Creation",
                      icon: (
                        <ReceiptOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: false,
                      showForCompany: true,
                      showForCustomer: false,
                    },
                    {
                      key: "workers",
                      label: "Worker Creation",
                      icon: (
                        <EngineeringOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: false,
                      showForCompany: true,
                      showForCustomer: false,
                    },
                    {
                      key: "AppointmentConfirmNotification",
                      label: "Customer Appointment Confirmation	",
                      icon: (
                        <EventNoteOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: false,
                      showForCompany: true,
                      showForCustomer: true,
                    },
                    {
                      key: "QuoteConfirmNotification",
                      label: "Worker Quote Confirmation	",
                      icon: (
                        <CheckCircleOutlineOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: false,
                      showForCompany: true,
                      showForCustomer: true,
                    },
                    {
                      key: "QuoteChangeRequestNotification",
                      label: "Change Request",
                      icon: (
                        <SyncAltOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: false,
                      showForCompany: true,
                      showForCustomer: true,
                    },
                    {
                      key: "ProductAndServiceCreateNotification",
                      label: "Materials & Labor",
                      icon: (
                        <BuildOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: false,
                      showForCompany: true,
                      showForCustomer: false,
                    },
                    {
                      key: "ManageAccountNotification",
                      label: "Manage Account",
                      icon: (
                        <AccountBalanceWalletOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: true,
                      showForCompany: true,
                      showForCustomer: false,
                    },
                    {
                      key: "ManageTempletes",
                      label: "Template Creation",
                      icon: (
                        <FileCopyOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: true,
                      showForCompany: true,
                      showForCustomer: false,
                    },
                    {
                      key: "RecurringChargeNotification",
                      label: "Recurring Charges Made",
                      icon: (
                        <PaymentsOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: true,
                      showForCompany: true,
                      showForCustomer: false,
                    },
                    {
                      key: "RecurringPaymentNotification",
                      label: "Recurring Payments Made",
                      icon: (
                        <AccountBalanceOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: true,
                      showForCompany: true,
                      showForCustomer: false,
                    },
                    {
                      key: "AddVisitNotifications",
                      label: "Visit Create",
                      icon: (
                        <HomeOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: false,
                      showForCompany: true,
                      showForCustomer: false,
                    },
                    {
                      key: "Quotesignature",
                      label: "Signatures Request/Approval",
                      icon: (
                        <DrawOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: false,
                      showForCompany: true,
                      showForCustomer: false,
                    },
                    {
                      key: "OneTimeChargeNotification",
                      label: "One-time Charge Creation",
                      icon: (
                        <CreditCardOutlinedIcon
                          className={
                            isDonationMode ? "text-donor-color" : ""
                          }
                          sx={{
                            fontSize: 24,
                            ...(!isDonationMode && { color: jobberAmber }),
                          }}
                        />
                      ),
                      showForDonor: true,
                      showForCompany: true,
                      showForCustomer: false,
                    },
                  ]
                    .filter((item) => {
                      // Check if user role is Customer and hide sections accordingly
                      if (authNav?.Role === "Customer") {
                        return item?.showForCustomer;
                      }
                      
                      if (isDonationMode) {
                        return item?.showForDonor;
                      } else {
                        return item?.showForCompany;
                      }
                    })
                    .map((item) => (
                      <Grid
                        key={item?.key}
                        className="notification-contant notification-feed-customize-row d-flex justify-content-between"
                        style={{
                          padding: "16px 24px",
                          borderBottom: "1px solid #f0f2f5",
                          transition: "all 0.3s ease",
                          borderRadius: "8px",
                          margin: "4px 0",
                        }}
                      >
                        <Typography
                          className="notification-feed-customize-label"
                          style={{
                            fontWeight: "600",
                            color: "#374151",
                            fontSize: "14px",
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setisSwitchOn((pre) => ({
                              ...pre,
                              [item?.key]: !pre?.[item?.key],
                            }));
                          }}
                        >
                          {item?.icon}
                          {item?.label}
                        </Typography>

                        <AntSwitch
                          checked={isSwitchOn?.[item?.key || ""]}
                          onChange={handleSwitchChange}
                          inputProps={{ "aria-label": "ant design" }}
                          name={item?.key}
                          isDonationMode={isDonationMode}
                        />
                      </Grid>
                    ))}
                </Grid>
              </Grid>
            )}
          </Grid>
          </>
        )}

      {/* AI Chat Component */}
      <AIChat isOpen={isAIChatOpen} onClose={handleAIChatClose} />
    </>
  );
};

export const refreshNotifications = () => {
  if (globalNotificationRefresh) {
    globalNotificationRefresh();
  } else {
    console.warn(
      "Notification refresh function not available - MainNav not mounted"
    );
  }
};

export {
  JobberTable,
  JobberPagination,
  JobberSearch,
  JobberListCard,
  JobberListCardLoaderContext,
  MainNav,
  JobberSorting,
  JobberSearchDropdown,
};

